import _e, { useRef as Be, useCallback as Ee, useEffect as Je, useMemo as Ge, useDebugValue as Yo, useState as Ce, useReducer as Go, forwardRef as Ko, useImperativeHandle as Qo, Fragment as Jo } from "react";
import Oe from "next/link";
import b, { css as Ne } from "styled-components";
import Xo from "react-dom";
import Zo from "next/image";
const ea = Symbol(), Ir = Symbol(), _t = "a", Tt = "w";
let ta = (e, t) => new Proxy(e, t);
const Or = Object.getPrototypeOf, Tr = /* @__PURE__ */ new WeakMap(), Kn = (e) => e && (Tr.has(e) ? Tr.get(e) : Or(e) === Object.prototype || Or(e) === Array.prototype), Ut = (e) => typeof e == "object" && e !== null, ra = (e) => {
  if (Array.isArray(e))
    return Array.from(e);
  const t = Object.getOwnPropertyDescriptors(e);
  return Object.values(t).forEach((r) => {
    r.configurable = !0;
  }), Object.create(Or(e), t);
}, Nr = (e) => e[Ir] || e, Qn = (e, t, r, n) => {
  if (!Kn(e))
    return e;
  let a = n && n.get(e);
  if (!a) {
    const f = Nr(e);
    a = ((c) => Object.values(Object.getOwnPropertyDescriptors(c)).some((d) => !d.configurable && !d.writable))(f) ? [f, ra(f)] : [f], n == null || n.set(e, a);
  }
  const [i, u] = a;
  let o = r && r.get(i);
  return o && o[1].f === !!u || (o = ((f, c) => {
    const d = { f: c };
    let p = !1;
    const v = (O, y) => {
      if (!p) {
        let D = d[_t].get(f);
        if (D || (D = {}, d[_t].set(f, D)), O === Tt)
          D[Tt] = !0;
        else {
          let W = D[O];
          W || (W = /* @__PURE__ */ new Set(), D[O] = W), W.add(y);
        }
      }
    }, w = { get: (O, y) => y === Ir ? f : (v("k", y), Qn(Reflect.get(O, y), d[_t], d.c)), has: (O, y) => y === ea ? (p = !0, d[_t].delete(f), !0) : (v("h", y), Reflect.has(O, y)), getOwnPropertyDescriptor: (O, y) => (v("o", y), Reflect.getOwnPropertyDescriptor(O, y)), ownKeys: (O) => (v(Tt), Reflect.ownKeys(O)) };
    return c && (w.set = w.deleteProperty = () => !1), [w, d];
  })(i, !!u), o[1].p = ta(u || i, o[0]), r && r.set(i, o)), o[1][_t] = t, o[1].c = r, o[1].p;
}, Jn = (e, t, r, n) => {
  if (Object.is(e, t))
    return !1;
  if (!Ut(e) || !Ut(t))
    return !0;
  const a = r.get(Nr(e));
  if (!a)
    return !0;
  if (n) {
    const u = n.get(e);
    if (u && u.n === t)
      return u.g;
    n.set(e, { n: t, g: !1 });
  }
  let i = null;
  try {
    for (const u of a.h || [])
      if (i = Reflect.has(e, u) !== Reflect.has(t, u), i)
        return i;
    if (a[Tt] === !0) {
      if (i = ((u, o) => {
        const f = Reflect.ownKeys(u), c = Reflect.ownKeys(o);
        return f.length !== c.length || f.some((d, p) => d !== c[p]);
      })(e, t), i)
        return i;
    } else
      for (const u of a.o || [])
        if (i = !!Reflect.getOwnPropertyDescriptor(e, u) != !!Reflect.getOwnPropertyDescriptor(t, u), i)
          return i;
    for (const u of a.k || [])
      if (i = Jn(e[u], t[u], r, n), i)
        return i;
    return i === null && (i = !0), i;
  } finally {
    n && n.set(e, { n: t, g: i });
  }
}, na = (e) => Kn(e) && e[Ir] || null, tn = (e, t = !0) => {
  Tr.set(e, t);
}, oa = (e, t, r) => {
  const n = [], a = /* @__PURE__ */ new WeakSet(), i = (u, o) => {
    if (a.has(u))
      return;
    Ut(u) && a.add(u);
    const f = Ut(u) && t.get(Nr(u));
    if (f) {
      var c, d;
      if ((c = f.h) == null || c.forEach((v) => {
        const w = `:has(${String(v)})`;
        n.push(o ? [...o, w] : [w]);
      }), f[Tt] === !0) {
        const v = ":ownKeys";
        n.push(o ? [...o, v] : [v]);
      } else {
        var p;
        (p = f.o) == null || p.forEach((v) => {
          const w = `:hasOwn(${String(v)})`;
          n.push(o ? [...o, w] : [w]);
        });
      }
      (d = f.k) == null || d.forEach((v) => {
        r && !("value" in (Object.getOwnPropertyDescriptor(u, v) || {})) || i(u[v], o ? [...o, v] : [v]);
      });
    } else
      o && n.push(o);
  };
  return i(e), n;
}, lr = (e) => typeof e == "object" && e !== null, ze = /* @__PURE__ */ new WeakMap(), kt = /* @__PURE__ */ new WeakSet(), aa = (e = Object.is, t = (c, d) => new Proxy(c, d), r = (c) => lr(c) && !kt.has(c) && (Array.isArray(c) || !(Symbol.iterator in c)) && !(c instanceof WeakMap) && !(c instanceof WeakSet) && !(c instanceof Error) && !(c instanceof Number) && !(c instanceof Date) && !(c instanceof String) && !(c instanceof RegExp) && !(c instanceof ArrayBuffer), n = (c) => {
  switch (c.status) {
    case "fulfilled":
      return c.value;
    case "rejected":
      throw c.reason;
    default:
      throw c;
  }
}, a = /* @__PURE__ */ new WeakMap(), i = (c, d, p = n) => {
  const v = a.get(c);
  if ((v == null ? void 0 : v[0]) === d)
    return v[1];
  const w = Array.isArray(c) ? [] : Object.create(Object.getPrototypeOf(c));
  return tn(w, !0), a.set(c, [d, w]), Reflect.ownKeys(c).forEach((O) => {
    if (Object.getOwnPropertyDescriptor(w, O))
      return;
    const y = Reflect.get(c, O), D = {
      value: y,
      enumerable: !0,
      // This is intentional to avoid copying with proxy-compare.
      // It's still non-writable, so it avoids assigning a value.
      configurable: !0
    };
    if (kt.has(y))
      tn(y, !1);
    else if (y instanceof Promise)
      delete D.value, D.get = () => p(y);
    else if (ze.has(y)) {
      const [W, X] = ze.get(
        y
      );
      D.value = i(
        W,
        X(),
        p
      );
    }
    Object.defineProperty(w, O, D);
  }), w;
}, u = /* @__PURE__ */ new WeakMap(), o = [1, 1], f = (c) => {
  if (!lr(c))
    throw new Error("object required");
  const d = u.get(c);
  if (d)
    return d;
  let p = o[0];
  const v = /* @__PURE__ */ new Set(), w = (I, z = ++o[0]) => {
    p !== z && (p = z, v.forEach((B) => B(I, z)));
  };
  let O = o[1];
  const y = (I = ++o[1]) => (O !== I && !v.size && (O = I, W.forEach(([z]) => {
    const B = z[1](I);
    B > p && (p = B);
  })), p), D = (I) => (z, B) => {
    const re = [...z];
    re[1] = [I, ...re[1]], w(re, B);
  }, W = /* @__PURE__ */ new Map(), X = (I, z) => {
    if (({ BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 } && "production") !== "production" && W.has(I))
      throw new Error("prop listener already exists");
    if (v.size) {
      const B = z[3](D(I));
      W.set(I, [z, B]);
    } else
      W.set(I, [z]);
  }, H = (I) => {
    var z;
    const B = W.get(I);
    B && (W.delete(I), (z = B[1]) == null || z.call(B));
  }, U = (I) => (v.add(I), v.size === 1 && W.forEach(([B, re], te) => {
    if (({ BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 } && "production") !== "production" && re)
      throw new Error("remove already exists");
    const A = B[3](D(te));
    W.set(te, [B, A]);
  }), () => {
    v.delete(I), v.size === 0 && W.forEach(([B, re], te) => {
      re && (re(), W.set(te, [B]));
    });
  }), E = Array.isArray(c) ? [] : Object.create(Object.getPrototypeOf(c)), oe = t(E, {
    deleteProperty(I, z) {
      const B = Reflect.get(I, z);
      H(z);
      const re = Reflect.deleteProperty(I, z);
      return re && w(["delete", [z], B]), re;
    },
    set(I, z, B, re) {
      const te = Reflect.has(I, z), A = Reflect.get(I, z, re);
      if (te && (e(A, B) || u.has(B) && e(A, u.get(B))))
        return !0;
      H(z), lr(B) && (B = na(B) || B);
      let k = B;
      if (B instanceof Promise)
        B.then((Y) => {
          B.status = "fulfilled", B.value = Y, w(["resolve", [z], Y]);
        }).catch((Y) => {
          B.status = "rejected", B.reason = Y, w(["reject", [z], Y]);
        });
      else {
        !ze.has(B) && r(B) && (k = f(B));
        const Y = !kt.has(k) && ze.get(k);
        Y && X(z, Y);
      }
      return Reflect.set(I, z, k, re), w(["set", [z], B, A]), !0;
    }
  });
  u.set(c, oe);
  const ue = [
    E,
    y,
    i,
    U
  ];
  return ze.set(oe, ue), Reflect.ownKeys(c).forEach((I) => {
    const z = Object.getOwnPropertyDescriptor(
      c,
      I
    );
    "value" in z && (oe[I] = c[I], delete z.value, delete z.writable), Object.defineProperty(E, I, z);
  }), oe;
}) => [
  // public functions
  f,
  // shared state
  ze,
  kt,
  // internal things
  e,
  t,
  r,
  n,
  a,
  i,
  u,
  o
], [ia] = aa();
function Xn(e = {}) {
  return ia(e);
}
function sa(e, t, r) {
  const n = ze.get(e);
  ({ BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 } && "production") !== "production" && !n && console.warn("Please use proxy object");
  let a;
  const i = [], u = n[3];
  let o = !1;
  const c = u((d) => {
    if (i.push(d), r) {
      t(i.splice(0));
      return;
    }
    a || (a = Promise.resolve().then(() => {
      a = void 0, o && t(i.splice(0));
    }));
  });
  return o = !0, () => {
    o = !1, c();
  };
}
function rn(e, t) {
  const r = ze.get(e);
  ({ BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 } && "production") !== "production" && !r && console.warn("Please use proxy object");
  const [n, a, i] = r;
  return i(n, a(), t);
}
var ca = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Wr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function la(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      if (this instanceof n) {
        var a = [null];
        a.push.apply(a, arguments);
        var i = Function.bind.apply(t, a);
        return new i();
      }
      return t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var a = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, a.get ? a : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var Cr = {}, ua = {
  get exports() {
    return Cr;
  },
  set exports(e) {
    Cr = e;
  }
}, ur = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var nn;
function fa() {
  if (nn)
    return ur;
  nn = 1;
  var e = _e;
  function t(p, v) {
    return p === v && (p !== 0 || 1 / p === 1 / v) || p !== p && v !== v;
  }
  var r = typeof Object.is == "function" ? Object.is : t, n = e.useState, a = e.useEffect, i = e.useLayoutEffect, u = e.useDebugValue;
  function o(p, v) {
    var w = v(), O = n({ inst: { value: w, getSnapshot: v } }), y = O[0].inst, D = O[1];
    return i(function() {
      y.value = w, y.getSnapshot = v, f(y) && D({ inst: y });
    }, [p, w, v]), a(function() {
      return f(y) && D({ inst: y }), p(function() {
        f(y) && D({ inst: y });
      });
    }, [p]), u(w), w;
  }
  function f(p) {
    var v = p.getSnapshot;
    p = p.value;
    try {
      var w = v();
      return !r(p, w);
    } catch {
      return !0;
    }
  }
  function c(p, v) {
    return v();
  }
  var d = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : o;
  return ur.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : d, ur;
}
var fr = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var on;
function da() {
  return on || (on = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = _e, t = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function r(H) {
      {
        for (var U = arguments.length, E = new Array(U > 1 ? U - 1 : 0), Z = 1; Z < U; Z++)
          E[Z - 1] = arguments[Z];
        n("error", H, E);
      }
    }
    function n(H, U, E) {
      {
        var Z = t.ReactDebugCurrentFrame, oe = Z.getStackAddendum();
        oe !== "" && (U += "%s", E = E.concat([oe]));
        var ue = E.map(function(I) {
          return String(I);
        });
        ue.unshift("Warning: " + U), Function.prototype.apply.call(console[H], console, ue);
      }
    }
    function a(H, U) {
      return H === U && (H !== 0 || 1 / H === 1 / U) || H !== H && U !== U;
    }
    var i = typeof Object.is == "function" ? Object.is : a, u = e.useState, o = e.useEffect, f = e.useLayoutEffect, c = e.useDebugValue, d = !1, p = !1;
    function v(H, U, E) {
      d || e.startTransition !== void 0 && (d = !0, r("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var Z = U();
      if (!p) {
        var oe = U();
        i(Z, oe) || (r("The result of getSnapshot should be cached to avoid an infinite loop"), p = !0);
      }
      var ue = u({
        inst: {
          value: Z,
          getSnapshot: U
        }
      }), I = ue[0].inst, z = ue[1];
      return f(function() {
        I.value = Z, I.getSnapshot = U, w(I) && z({
          inst: I
        });
      }, [H, Z, U]), o(function() {
        w(I) && z({
          inst: I
        });
        var B = function() {
          w(I) && z({
            inst: I
          });
        };
        return H(B);
      }, [H]), c(Z), Z;
    }
    function w(H) {
      var U = H.getSnapshot, E = H.value;
      try {
        var Z = U();
        return !i(E, Z);
      } catch {
        return !0;
      }
    }
    function O(H, U, E) {
      return U();
    }
    var y = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", D = !y, W = D ? O : v, X = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : W;
    fr.useSyncExternalStore = X, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), fr;
}
(function(e) {
  process.env.NODE_ENV === "production" ? e.exports = fa() : e.exports = da();
})(ua);
const pa = /* @__PURE__ */ Wr(Cr), { use: an } = _e, { useSyncExternalStore: ha } = pa, va = (e, t) => {
  const r = Be();
  Je(() => {
    r.current = oa(e, t, !0);
  }), Yo(r.current);
}, ma = /* @__PURE__ */ new WeakMap();
function Zn(e, t) {
  const r = t == null ? void 0 : t.sync, n = Be(), a = Be();
  let i = !0;
  const u = ha(
    Ee(
      (c) => {
        const d = sa(e, c, r);
        return c(), d;
      },
      [e, r]
    ),
    () => {
      const c = rn(e, an);
      try {
        if (!i && n.current && a.current && !Jn(
          n.current,
          c,
          a.current,
          /* @__PURE__ */ new WeakMap()
        ))
          return n.current;
      } catch {
      }
      return c;
    },
    () => rn(e, an)
  );
  i = !1;
  const o = /* @__PURE__ */ new WeakMap();
  Je(() => {
    n.current = u, a.current = o;
  }), ({ BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 } && "production") !== "production" && va(u, o);
  const f = Ge(() => /* @__PURE__ */ new WeakMap(), []);
  return Qn(
    u,
    o,
    f,
    ma
  );
}
const eo = Xn({
  isLanguageMenuDisplayed: !1
}), sn = (e) => {
  eo.isLanguageMenuDisplayed = e;
}, ga = () => eo, Ur = Xn({}), cn = (e) => {
  Ur.lgtmImages = e;
}, Ft = (e) => {
  Ur.isFailedFetchLgtmImages = e;
}, ya = () => Ur, zr = () => {
  const e = Zn(ga()), { isLanguageMenuDisplayed: t } = e;
  return {
    isLanguageMenuDisplayed: t,
    onClickLanguageButton: (a) => {
      sn(!t);
    },
    onClickOutSideMenu: (a) => {
      t && sn(!1);
    }
  };
};
var jr = {}, xa = {
  get exports() {
    return jr;
  },
  set exports(e) {
    jr = e;
  }
};
/*!
 * clipboard.js v2.0.11
 * https://clipboardjs.com/
 *
 * Licensed MIT © Zeno Rocha
 */
(function(e, t) {
  (function(n, a) {
    e.exports = a();
  })(ca, function() {
    return (
      /******/
      function() {
        var r = {
          /***/
          686: (
            /***/
            function(i, u, o) {
              o.d(u, {
                default: function() {
                  return (
                    /* binding */
                    _
                  );
                }
              });
              var f = o(279), c = /* @__PURE__ */ o.n(f), d = o(370), p = /* @__PURE__ */ o.n(d), v = o(817), w = /* @__PURE__ */ o.n(v);
              function O(T) {
                try {
                  return document.execCommand(T);
                } catch {
                  return !1;
                }
              }
              var y = function(x) {
                var g = w()(x);
                return O("cut"), g;
              }, D = y;
              function W(T) {
                var x = document.documentElement.getAttribute("dir") === "rtl", g = document.createElement("textarea");
                g.style.fontSize = "12pt", g.style.border = "0", g.style.padding = "0", g.style.margin = "0", g.style.position = "absolute", g.style[x ? "right" : "left"] = "-9999px";
                var R = window.pageYOffset || document.documentElement.scrollTop;
                return g.style.top = "".concat(R, "px"), g.setAttribute("readonly", ""), g.value = T, g;
              }
              var X = function(x, g) {
                var R = W(x);
                g.container.appendChild(R);
                var C = w()(R);
                return O("copy"), R.remove(), C;
              }, H = function(x) {
                var g = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
                  container: document.body
                }, R = "";
                return typeof x == "string" ? R = X(x, g) : x instanceof HTMLInputElement && !["text", "search", "url", "tel", "password"].includes(x == null ? void 0 : x.type) ? R = X(x.value, g) : (R = w()(x), O("copy")), R;
              }, U = H;
              function E(T) {
                return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? E = function(g) {
                  return typeof g;
                } : E = function(g) {
                  return g && typeof Symbol == "function" && g.constructor === Symbol && g !== Symbol.prototype ? "symbol" : typeof g;
                }, E(T);
              }
              var Z = function() {
                var x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, g = x.action, R = g === void 0 ? "copy" : g, C = x.container, P = x.target, V = x.text;
                if (R !== "copy" && R !== "cut")
                  throw new Error('Invalid "action" value, use either "copy" or "cut"');
                if (P !== void 0)
                  if (P && E(P) === "object" && P.nodeType === 1) {
                    if (R === "copy" && P.hasAttribute("disabled"))
                      throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                    if (R === "cut" && (P.hasAttribute("readonly") || P.hasAttribute("disabled")))
                      throw new Error(`Invalid "target" attribute. You can't cut text from elements with "readonly" or "disabled" attributes`);
                  } else
                    throw new Error('Invalid "target" value, use a valid Element');
                if (V)
                  return U(V, {
                    container: C
                  });
                if (P)
                  return R === "cut" ? D(P) : U(P, {
                    container: C
                  });
              }, oe = Z;
              function ue(T) {
                return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? ue = function(g) {
                  return typeof g;
                } : ue = function(g) {
                  return g && typeof Symbol == "function" && g.constructor === Symbol && g !== Symbol.prototype ? "symbol" : typeof g;
                }, ue(T);
              }
              function I(T, x) {
                if (!(T instanceof x))
                  throw new TypeError("Cannot call a class as a function");
              }
              function z(T, x) {
                for (var g = 0; g < x.length; g++) {
                  var R = x[g];
                  R.enumerable = R.enumerable || !1, R.configurable = !0, "value" in R && (R.writable = !0), Object.defineProperty(T, R.key, R);
                }
              }
              function B(T, x, g) {
                return x && z(T.prototype, x), g && z(T, g), T;
              }
              function re(T, x) {
                if (typeof x != "function" && x !== null)
                  throw new TypeError("Super expression must either be null or a function");
                T.prototype = Object.create(x && x.prototype, { constructor: { value: T, writable: !0, configurable: !0 } }), x && te(T, x);
              }
              function te(T, x) {
                return te = Object.setPrototypeOf || function(R, C) {
                  return R.__proto__ = C, R;
                }, te(T, x);
              }
              function A(T) {
                var x = h();
                return function() {
                  var R = N(T), C;
                  if (x) {
                    var P = N(this).constructor;
                    C = Reflect.construct(R, arguments, P);
                  } else
                    C = R.apply(this, arguments);
                  return k(this, C);
                };
              }
              function k(T, x) {
                return x && (ue(x) === "object" || typeof x == "function") ? x : Y(T);
              }
              function Y(T) {
                if (T === void 0)
                  throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return T;
              }
              function h() {
                if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
                  return !1;
                if (typeof Proxy == "function")
                  return !0;
                try {
                  return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
                  })), !0;
                } catch {
                  return !1;
                }
              }
              function N(T) {
                return N = Object.setPrototypeOf ? Object.getPrototypeOf : function(g) {
                  return g.__proto__ || Object.getPrototypeOf(g);
                }, N(T);
              }
              function L(T, x) {
                var g = "data-clipboard-".concat(T);
                if (x.hasAttribute(g))
                  return x.getAttribute(g);
              }
              var m = /* @__PURE__ */ function(T) {
                re(g, T);
                var x = A(g);
                function g(R, C) {
                  var P;
                  return I(this, g), P = x.call(this), P.resolveOptions(C), P.listenClick(R), P;
                }
                return B(g, [{
                  key: "resolveOptions",
                  value: function() {
                    var C = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                    this.action = typeof C.action == "function" ? C.action : this.defaultAction, this.target = typeof C.target == "function" ? C.target : this.defaultTarget, this.text = typeof C.text == "function" ? C.text : this.defaultText, this.container = ue(C.container) === "object" ? C.container : document.body;
                  }
                  /**
                   * Adds a click event listener to the passed trigger.
                   * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
                   */
                }, {
                  key: "listenClick",
                  value: function(C) {
                    var P = this;
                    this.listener = p()(C, "click", function(V) {
                      return P.onClick(V);
                    });
                  }
                  /**
                   * Defines a new `ClipboardAction` on each click event.
                   * @param {Event} e
                   */
                }, {
                  key: "onClick",
                  value: function(C) {
                    var P = C.delegateTarget || C.currentTarget, V = this.action(P) || "copy", J = oe({
                      action: V,
                      container: this.container,
                      target: this.target(P),
                      text: this.text(P)
                    });
                    this.emit(J ? "success" : "error", {
                      action: V,
                      text: J,
                      trigger: P,
                      clearSelection: function() {
                        P && P.focus(), window.getSelection().removeAllRanges();
                      }
                    });
                  }
                  /**
                   * Default `action` lookup function.
                   * @param {Element} trigger
                   */
                }, {
                  key: "defaultAction",
                  value: function(C) {
                    return L("action", C);
                  }
                  /**
                   * Default `target` lookup function.
                   * @param {Element} trigger
                   */
                }, {
                  key: "defaultTarget",
                  value: function(C) {
                    var P = L("target", C);
                    if (P)
                      return document.querySelector(P);
                  }
                  /**
                   * Allow fire programmatically a copy action
                   * @param {String|HTMLElement} target
                   * @param {Object} options
                   * @returns Text copied.
                   */
                }, {
                  key: "defaultText",
                  /**
                   * Default `text` lookup function.
                   * @param {Element} trigger
                   */
                  value: function(C) {
                    return L("text", C);
                  }
                  /**
                   * Destroy lifecycle.
                   */
                }, {
                  key: "destroy",
                  value: function() {
                    this.listener.destroy();
                  }
                }], [{
                  key: "copy",
                  value: function(C) {
                    var P = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
                      container: document.body
                    };
                    return U(C, P);
                  }
                  /**
                   * Allow fire programmatically a cut action
                   * @param {String|HTMLElement} target
                   * @returns Text cutted.
                   */
                }, {
                  key: "cut",
                  value: function(C) {
                    return D(C);
                  }
                  /**
                   * Returns the support of the given action, or all actions if no action is
                   * given.
                   * @param {String} [action]
                   */
                }, {
                  key: "isSupported",
                  value: function() {
                    var C = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ["copy", "cut"], P = typeof C == "string" ? [C] : C, V = !!document.queryCommandSupported;
                    return P.forEach(function(J) {
                      V = V && !!document.queryCommandSupported(J);
                    }), V;
                  }
                }]), g;
              }(c()), _ = m;
            }
          ),
          /***/
          828: (
            /***/
            function(i) {
              var u = 9;
              if (typeof Element < "u" && !Element.prototype.matches) {
                var o = Element.prototype;
                o.matches = o.matchesSelector || o.mozMatchesSelector || o.msMatchesSelector || o.oMatchesSelector || o.webkitMatchesSelector;
              }
              function f(c, d) {
                for (; c && c.nodeType !== u; ) {
                  if (typeof c.matches == "function" && c.matches(d))
                    return c;
                  c = c.parentNode;
                }
              }
              i.exports = f;
            }
          ),
          /***/
          438: (
            /***/
            function(i, u, o) {
              var f = o(828);
              function c(v, w, O, y, D) {
                var W = p.apply(this, arguments);
                return v.addEventListener(O, W, D), {
                  destroy: function() {
                    v.removeEventListener(O, W, D);
                  }
                };
              }
              function d(v, w, O, y, D) {
                return typeof v.addEventListener == "function" ? c.apply(null, arguments) : typeof O == "function" ? c.bind(null, document).apply(null, arguments) : (typeof v == "string" && (v = document.querySelectorAll(v)), Array.prototype.map.call(v, function(W) {
                  return c(W, w, O, y, D);
                }));
              }
              function p(v, w, O, y) {
                return function(D) {
                  D.delegateTarget = f(D.target, w), D.delegateTarget && y.call(v, D);
                };
              }
              i.exports = d;
            }
          ),
          /***/
          879: (
            /***/
            function(i, u) {
              u.node = function(o) {
                return o !== void 0 && o instanceof HTMLElement && o.nodeType === 1;
              }, u.nodeList = function(o) {
                var f = Object.prototype.toString.call(o);
                return o !== void 0 && (f === "[object NodeList]" || f === "[object HTMLCollection]") && "length" in o && (o.length === 0 || u.node(o[0]));
              }, u.string = function(o) {
                return typeof o == "string" || o instanceof String;
              }, u.fn = function(o) {
                var f = Object.prototype.toString.call(o);
                return f === "[object Function]";
              };
            }
          ),
          /***/
          370: (
            /***/
            function(i, u, o) {
              var f = o(879), c = o(438);
              function d(O, y, D) {
                if (!O && !y && !D)
                  throw new Error("Missing required arguments");
                if (!f.string(y))
                  throw new TypeError("Second argument must be a String");
                if (!f.fn(D))
                  throw new TypeError("Third argument must be a Function");
                if (f.node(O))
                  return p(O, y, D);
                if (f.nodeList(O))
                  return v(O, y, D);
                if (f.string(O))
                  return w(O, y, D);
                throw new TypeError("First argument must be a String, HTMLElement, HTMLCollection, or NodeList");
              }
              function p(O, y, D) {
                return O.addEventListener(y, D), {
                  destroy: function() {
                    O.removeEventListener(y, D);
                  }
                };
              }
              function v(O, y, D) {
                return Array.prototype.forEach.call(O, function(W) {
                  W.addEventListener(y, D);
                }), {
                  destroy: function() {
                    Array.prototype.forEach.call(O, function(W) {
                      W.removeEventListener(y, D);
                    });
                  }
                };
              }
              function w(O, y, D) {
                return c(document.body, O, y, D);
              }
              i.exports = d;
            }
          ),
          /***/
          817: (
            /***/
            function(i) {
              function u(o) {
                var f;
                if (o.nodeName === "SELECT")
                  o.focus(), f = o.value;
                else if (o.nodeName === "INPUT" || o.nodeName === "TEXTAREA") {
                  var c = o.hasAttribute("readonly");
                  c || o.setAttribute("readonly", ""), o.select(), o.setSelectionRange(0, o.value.length), c || o.removeAttribute("readonly"), f = o.value;
                } else {
                  o.hasAttribute("contenteditable") && o.focus();
                  var d = window.getSelection(), p = document.createRange();
                  p.selectNodeContents(o), d.removeAllRanges(), d.addRange(p), f = d.toString();
                }
                return f;
              }
              i.exports = u;
            }
          ),
          /***/
          279: (
            /***/
            function(i) {
              function u() {
              }
              u.prototype = {
                on: function(o, f, c) {
                  var d = this.e || (this.e = {});
                  return (d[o] || (d[o] = [])).push({
                    fn: f,
                    ctx: c
                  }), this;
                },
                once: function(o, f, c) {
                  var d = this;
                  function p() {
                    d.off(o, p), f.apply(c, arguments);
                  }
                  return p._ = f, this.on(o, p, c);
                },
                emit: function(o) {
                  var f = [].slice.call(arguments, 1), c = ((this.e || (this.e = {}))[o] || []).slice(), d = 0, p = c.length;
                  for (d; d < p; d++)
                    c[d].fn.apply(c[d].ctx, f);
                  return this;
                },
                off: function(o, f) {
                  var c = this.e || (this.e = {}), d = c[o], p = [];
                  if (d && f)
                    for (var v = 0, w = d.length; v < w; v++)
                      d[v].fn !== f && d[v].fn._ !== f && p.push(d[v]);
                  return p.length ? c[o] = p : delete c[o], this;
                }
              }, i.exports = u, i.exports.TinyEmitter = u;
            }
          )
          /******/
        }, n = {};
        function a(i) {
          if (n[i])
            return n[i].exports;
          var u = n[i] = {
            /******/
            // no module.id needed
            /******/
            // no module.loaded needed
            /******/
            exports: {}
            /******/
          };
          return r[i](u, u.exports, a), u.exports;
        }
        return function() {
          a.n = function(i) {
            var u = i && i.__esModule ? (
              /******/
              function() {
                return i.default;
              }
            ) : (
              /******/
              function() {
                return i;
              }
            );
            return a.d(u, { a: u }), u;
          };
        }(), function() {
          a.d = function(i, u) {
            for (var o in u)
              a.o(u, o) && !a.o(i, o) && Object.defineProperty(i, o, { enumerable: !0, get: u[o] });
          };
        }(), function() {
          a.o = function(i, u) {
            return Object.prototype.hasOwnProperty.call(i, u);
          };
        }(), a(686);
      }().default
    );
  });
})(xa);
const ba = /* @__PURE__ */ Wr(jr), Xt = ({
  onCopySuccess: e,
  imageUrl: t,
  appUrl: r
}) => {
  const n = Be(null);
  return Je(() => {
    const a = new ba(n.current, {
      text: () => `[![LGTMeow](${t})](${r})`
    });
    return a.on("success", () => {
      e();
    }), () => {
      a.destroy();
    };
  }, [e, t, r]), { imageContextRef: n };
}, Zt = (e) => {
  const [t, r] = Ce(!1), n = Ee(() => {
    e && e();
    const a = 1e3;
    r(!0), setTimeout(() => {
      r(!1);
    }, a);
  }, [e]);
  return { copied: t, onCopySuccess: n };
};
var l = {}, wa = {
  get exports() {
    return l;
  },
  set exports(e) {
    l = e;
  }
}, St = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ln;
function Ea() {
  if (ln)
    return St;
  ln = 1;
  var e = _e, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function u(o, f, c) {
    var d, p = {}, v = null, w = null;
    c !== void 0 && (v = "" + c), f.key !== void 0 && (v = "" + f.key), f.ref !== void 0 && (w = f.ref);
    for (d in f)
      n.call(f, d) && !i.hasOwnProperty(d) && (p[d] = f[d]);
    if (o && o.defaultProps)
      for (d in f = o.defaultProps, f)
        p[d] === void 0 && (p[d] = f[d]);
    return { $$typeof: t, type: o, key: v, ref: w, props: p, _owner: a.current };
  }
  return St.Fragment = r, St.jsx = u, St.jsxs = u, St;
}
var Ot = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var un;
function _a() {
  return un || (un = 1, process.env.NODE_ENV !== "production" && function() {
    var e = _e, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), u = Symbol.for("react.provider"), o = Symbol.for("react.context"), f = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), v = Symbol.for("react.lazy"), w = Symbol.for("react.offscreen"), O = Symbol.iterator, y = "@@iterator";
    function D(s) {
      if (s === null || typeof s != "object")
        return null;
      var S = O && s[O] || s[y];
      return typeof S == "function" ? S : null;
    }
    var W = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function X(s) {
      {
        for (var S = arguments.length, F = new Array(S > 1 ? S - 1 : 0), G = 1; G < S; G++)
          F[G - 1] = arguments[G];
        H("error", s, F);
      }
    }
    function H(s, S, F) {
      {
        var G = W.ReactDebugCurrentFrame, ae = G.getStackAddendum();
        ae !== "" && (S += "%s", F = F.concat([ae]));
        var fe = F.map(function(ne) {
          return String(ne);
        });
        fe.unshift("Warning: " + S), Function.prototype.apply.call(console[s], console, fe);
      }
    }
    var U = !1, E = !1, Z = !1, oe = !1, ue = !1, I;
    I = Symbol.for("react.module.reference");
    function z(s) {
      return !!(typeof s == "string" || typeof s == "function" || s === n || s === i || ue || s === a || s === c || s === d || oe || s === w || U || E || Z || typeof s == "object" && s !== null && (s.$$typeof === v || s.$$typeof === p || s.$$typeof === u || s.$$typeof === o || s.$$typeof === f || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      s.$$typeof === I || s.getModuleId !== void 0));
    }
    function B(s, S, F) {
      var G = s.displayName;
      if (G)
        return G;
      var ae = S.displayName || S.name || "";
      return ae !== "" ? F + "(" + ae + ")" : F;
    }
    function re(s) {
      return s.displayName || "Context";
    }
    function te(s) {
      if (s == null)
        return null;
      if (typeof s.tag == "number" && X("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof s == "function")
        return s.displayName || s.name || null;
      if (typeof s == "string")
        return s;
      switch (s) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case i:
          return "Profiler";
        case a:
          return "StrictMode";
        case c:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof s == "object")
        switch (s.$$typeof) {
          case o:
            var S = s;
            return re(S) + ".Consumer";
          case u:
            var F = s;
            return re(F._context) + ".Provider";
          case f:
            return B(s, s.render, "ForwardRef");
          case p:
            var G = s.displayName || null;
            return G !== null ? G : te(s.type) || "Memo";
          case v: {
            var ae = s, fe = ae._payload, ne = ae._init;
            try {
              return te(ne(fe));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var A = Object.assign, k = 0, Y, h, N, L, m, _, T;
    function x() {
    }
    x.__reactDisabledLog = !0;
    function g() {
      {
        if (k === 0) {
          Y = console.log, h = console.info, N = console.warn, L = console.error, m = console.group, _ = console.groupCollapsed, T = console.groupEnd;
          var s = {
            configurable: !0,
            enumerable: !0,
            value: x,
            writable: !0
          };
          Object.defineProperties(console, {
            info: s,
            log: s,
            warn: s,
            error: s,
            group: s,
            groupCollapsed: s,
            groupEnd: s
          });
        }
        k++;
      }
    }
    function R() {
      {
        if (k--, k === 0) {
          var s = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: A({}, s, {
              value: Y
            }),
            info: A({}, s, {
              value: h
            }),
            warn: A({}, s, {
              value: N
            }),
            error: A({}, s, {
              value: L
            }),
            group: A({}, s, {
              value: m
            }),
            groupCollapsed: A({}, s, {
              value: _
            }),
            groupEnd: A({}, s, {
              value: T
            })
          });
        }
        k < 0 && X("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var C = W.ReactCurrentDispatcher, P;
    function V(s, S, F) {
      {
        if (P === void 0)
          try {
            throw Error();
          } catch (ae) {
            var G = ae.stack.trim().match(/\n( *(at )?)/);
            P = G && G[1] || "";
          }
        return `
` + P + s;
      }
    }
    var J = !1, Q;
    {
      var ve = typeof WeakMap == "function" ? WeakMap : Map;
      Q = new ve();
    }
    function M(s, S) {
      if (!s || J)
        return "";
      {
        var F = Q.get(s);
        if (F !== void 0)
          return F;
      }
      var G;
      J = !0;
      var ae = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var fe;
      fe = C.current, C.current = null, g();
      try {
        if (S) {
          var ne = function() {
            throw Error();
          };
          if (Object.defineProperty(ne.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(ne, []);
            } catch (Ie) {
              G = Ie;
            }
            Reflect.construct(s, [], ne);
          } else {
            try {
              ne.call();
            } catch (Ie) {
              G = Ie;
            }
            s.call(ne.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Ie) {
            G = Ie;
          }
          s();
        }
      } catch (Ie) {
        if (Ie && G && typeof Ie.stack == "string") {
          for (var ee = Ie.stack.split(`
`), we = G.stack.split(`
`), me = ee.length - 1, ge = we.length - 1; me >= 1 && ge >= 0 && ee[me] !== we[ge]; )
            ge--;
          for (; me >= 1 && ge >= 0; me--, ge--)
            if (ee[me] !== we[ge]) {
              if (me !== 1 || ge !== 1)
                do
                  if (me--, ge--, ge < 0 || ee[me] !== we[ge]) {
                    var Te = `
` + ee[me].replace(" at new ", " at ");
                    return s.displayName && Te.includes("<anonymous>") && (Te = Te.replace("<anonymous>", s.displayName)), typeof s == "function" && Q.set(s, Te), Te;
                  }
                while (me >= 1 && ge >= 0);
              break;
            }
        }
      } finally {
        J = !1, C.current = fe, R(), Error.prepareStackTrace = ae;
      }
      var ct = s ? s.displayName || s.name : "", en = ct ? V(ct) : "";
      return typeof s == "function" && Q.set(s, en), en;
    }
    function xe(s, S, F) {
      return M(s, !1);
    }
    function ke(s) {
      var S = s.prototype;
      return !!(S && S.isReactComponent);
    }
    function Pe(s, S, F) {
      if (s == null)
        return "";
      if (typeof s == "function")
        return M(s, ke(s));
      if (typeof s == "string")
        return V(s);
      switch (s) {
        case c:
          return V("Suspense");
        case d:
          return V("SuspenseList");
      }
      if (typeof s == "object")
        switch (s.$$typeof) {
          case f:
            return xe(s.render);
          case p:
            return Pe(s.type, S, F);
          case v: {
            var G = s, ae = G._payload, fe = G._init;
            try {
              return Pe(fe(ae), S, F);
            } catch {
            }
          }
        }
      return "";
    }
    var qe = Object.prototype.hasOwnProperty, Fe = {}, ot = W.ReactDebugCurrentFrame;
    function $e(s) {
      if (s) {
        var S = s._owner, F = Pe(s.type, s._source, S ? S.type : null);
        ot.setExtraStackFrame(F);
      } else
        ot.setExtraStackFrame(null);
    }
    function at(s, S, F, G, ae) {
      {
        var fe = Function.call.bind(qe);
        for (var ne in s)
          if (fe(s, ne)) {
            var ee = void 0;
            try {
              if (typeof s[ne] != "function") {
                var we = Error((G || "React class") + ": " + F + " type `" + ne + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof s[ne] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw we.name = "Invariant Violation", we;
              }
              ee = s[ne](S, ne, G, F, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (me) {
              ee = me;
            }
            ee && !(ee instanceof Error) && ($e(ae), X("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", G || "React class", F, ne, typeof ee), $e(null)), ee instanceof Error && !(ee.message in Fe) && (Fe[ee.message] = !0, $e(ae), X("Failed %s type: %s", F, ee.message), $e(null));
          }
      }
    }
    var ar = Array.isArray;
    function vt(s) {
      return ar(s);
    }
    function ir(s) {
      {
        var S = typeof Symbol == "function" && Symbol.toStringTag, F = S && s[Symbol.toStringTag] || s.constructor.name || "Object";
        return F;
      }
    }
    function $(s) {
      try {
        return q(s), !1;
      } catch {
        return !0;
      }
    }
    function q(s) {
      return "" + s;
    }
    function de(s) {
      if ($(s))
        return X("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ir(s)), q(s);
    }
    var pe = W.ReactCurrentOwner, be = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ue, Le, Ye;
    Ye = {};
    function mt(s) {
      if (qe.call(s, "ref")) {
        var S = Object.getOwnPropertyDescriptor(s, "ref").get;
        if (S && S.isReactWarning)
          return !1;
      }
      return s.ref !== void 0;
    }
    function gt(s) {
      if (qe.call(s, "key")) {
        var S = Object.getOwnPropertyDescriptor(s, "key").get;
        if (S && S.isReactWarning)
          return !1;
      }
      return s.key !== void 0;
    }
    function it(s, S) {
      if (typeof s.ref == "string" && pe.current && S && pe.current.stateNode !== S) {
        var F = te(pe.current.type);
        Ye[F] || (X('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', te(pe.current.type), s.ref), Ye[F] = !0);
      }
    }
    function yt(s, S) {
      {
        var F = function() {
          Ue || (Ue = !0, X("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", S));
        };
        F.isReactWarning = !0, Object.defineProperty(s, "key", {
          get: F,
          configurable: !0
        });
      }
    }
    function xt(s, S) {
      {
        var F = function() {
          Le || (Le = !0, X("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", S));
        };
        F.isReactWarning = !0, Object.defineProperty(s, "ref", {
          get: F,
          configurable: !0
        });
      }
    }
    var bt = function(s, S, F, G, ae, fe, ne) {
      var ee = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: s,
        key: S,
        ref: F,
        props: ne,
        // Record the component responsible for creating this element.
        _owner: fe
      };
      return ee._store = {}, Object.defineProperty(ee._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(ee, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: G
      }), Object.defineProperty(ee, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ae
      }), Object.freeze && (Object.freeze(ee.props), Object.freeze(ee)), ee;
    };
    function wt(s, S, F, G, ae) {
      {
        var fe, ne = {}, ee = null, we = null;
        F !== void 0 && (de(F), ee = "" + F), gt(S) && (de(S.key), ee = "" + S.key), mt(S) && (we = S.ref, it(S, ae));
        for (fe in S)
          qe.call(S, fe) && !be.hasOwnProperty(fe) && (ne[fe] = S[fe]);
        if (s && s.defaultProps) {
          var me = s.defaultProps;
          for (fe in me)
            ne[fe] === void 0 && (ne[fe] = me[fe]);
        }
        if (ee || we) {
          var ge = typeof s == "function" ? s.displayName || s.name || "Unknown" : s;
          ee && yt(ne, ge), we && xt(ne, ge);
        }
        return bt(s, ee, we, ae, G, pe.current, ne);
      }
    }
    var Et = W.ReactCurrentOwner, Gr = W.ReactDebugCurrentFrame;
    function st(s) {
      if (s) {
        var S = s._owner, F = Pe(s.type, s._source, S ? S.type : null);
        Gr.setExtraStackFrame(F);
      } else
        Gr.setExtraStackFrame(null);
    }
    var sr;
    sr = !1;
    function cr(s) {
      return typeof s == "object" && s !== null && s.$$typeof === t;
    }
    function Kr() {
      {
        if (Et.current) {
          var s = te(Et.current.type);
          if (s)
            return `

Check the render method of \`` + s + "`.";
        }
        return "";
      }
    }
    function No(s) {
      {
        if (s !== void 0) {
          var S = s.fileName.replace(/^.*[\\\/]/, ""), F = s.lineNumber;
          return `

Check your code at ` + S + ":" + F + ".";
        }
        return "";
      }
    }
    var Qr = {};
    function Wo(s) {
      {
        var S = Kr();
        if (!S) {
          var F = typeof s == "string" ? s : s.displayName || s.name;
          F && (S = `

Check the top-level render call using <` + F + ">.");
        }
        return S;
      }
    }
    function Jr(s, S) {
      {
        if (!s._store || s._store.validated || s.key != null)
          return;
        s._store.validated = !0;
        var F = Wo(S);
        if (Qr[F])
          return;
        Qr[F] = !0;
        var G = "";
        s && s._owner && s._owner !== Et.current && (G = " It was passed a child from " + te(s._owner.type) + "."), st(s), X('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', F, G), st(null);
      }
    }
    function Xr(s, S) {
      {
        if (typeof s != "object")
          return;
        if (vt(s))
          for (var F = 0; F < s.length; F++) {
            var G = s[F];
            cr(G) && Jr(G, S);
          }
        else if (cr(s))
          s._store && (s._store.validated = !0);
        else if (s) {
          var ae = D(s);
          if (typeof ae == "function" && ae !== s.entries)
            for (var fe = ae.call(s), ne; !(ne = fe.next()).done; )
              cr(ne.value) && Jr(ne.value, S);
        }
      }
    }
    function Uo(s) {
      {
        var S = s.type;
        if (S == null || typeof S == "string")
          return;
        var F;
        if (typeof S == "function")
          F = S.propTypes;
        else if (typeof S == "object" && (S.$$typeof === f || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        S.$$typeof === p))
          F = S.propTypes;
        else
          return;
        if (F) {
          var G = te(S);
          at(F, s.props, "prop", G, s);
        } else if (S.PropTypes !== void 0 && !sr) {
          sr = !0;
          var ae = te(S);
          X("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ae || "Unknown");
        }
        typeof S.getDefaultProps == "function" && !S.getDefaultProps.isReactClassApproved && X("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function zo(s) {
      {
        for (var S = Object.keys(s.props), F = 0; F < S.length; F++) {
          var G = S[F];
          if (G !== "children" && G !== "key") {
            st(s), X("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", G), st(null);
            break;
          }
        }
        s.ref !== null && (st(s), X("Invalid attribute `ref` supplied to `React.Fragment`."), st(null));
      }
    }
    function Zr(s, S, F, G, ae, fe) {
      {
        var ne = z(s);
        if (!ne) {
          var ee = "";
          (s === void 0 || typeof s == "object" && s !== null && Object.keys(s).length === 0) && (ee += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var we = No(ae);
          we ? ee += we : ee += Kr();
          var me;
          s === null ? me = "null" : vt(s) ? me = "array" : s !== void 0 && s.$$typeof === t ? (me = "<" + (te(s.type) || "Unknown") + " />", ee = " Did you accidentally export a JSX literal instead of a component?") : me = typeof s, X("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", me, ee);
        }
        var ge = wt(s, S, F, ae, fe);
        if (ge == null)
          return ge;
        if (ne) {
          var Te = S.children;
          if (Te !== void 0)
            if (G)
              if (vt(Te)) {
                for (var ct = 0; ct < Te.length; ct++)
                  Xr(Te[ct], s);
                Object.freeze && Object.freeze(Te);
              } else
                X("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Xr(Te, s);
        }
        return s === n ? zo(ge) : Uo(ge), ge;
      }
    }
    function Bo(s, S, F) {
      return Zr(s, S, F, !0);
    }
    function Ho(s, S, F) {
      return Zr(s, S, F, !1);
    }
    var Vo = Ho, qo = Bo;
    Ot.Fragment = n, Ot.jsx = Vo, Ot.jsxs = qo;
  }()), Ot;
}
(function(e) {
  process.env.NODE_ENV === "production" ? e.exports = Ea() : e.exports = _a();
})(wa);
const to = "SuccessMarker", ro = "FailureMarker", nf = (e) => ({
  value: e,
  // eslint-disable-next-line id-length
  _: to
}), of = (e) => ({
  value: e,
  // eslint-disable-next-line id-length
  _: ro
}), af = (e) => "_" in e ? e._ === to : !1, sf = (e) => "_" in e ? e._ === ro : !1, Xe = {
  notFound: 404,
  internalServerError: 500,
  serviceUnavailable: 503
};
class Sa extends Error {
  constructor(t) {
    super(t), this.name = new.target.name, Error.captureStackTrace && Error.captureStackTrace(this, this.constructor);
  }
}
class Oa extends Error {
  constructor(t) {
    super(t), this.name = new.target.name, Error.captureStackTrace && Error.captureStackTrace(this, this.constructor);
  }
}
class dr extends Error {
  constructor(t) {
    super(t), this.name = new.target.name, Error.captureStackTrace && Error.captureStackTrace(this, this.constructor);
  }
}
const Ta = ["image/png", "image/jpg", "image/jpeg"], no = (e) => Ta.includes(e), Ca = (e) => {
  if (!no(e))
    throw new Oa(
      `${e} is not an allowed image extension`
    );
  return `.${e.replace("image/", "")}`;
}, le = (e) => {
  throw new Error("Unexpected value. Should have been never.");
}, Dt = (e) => {
  const t = "/privacy";
  switch (e) {
    case "en":
      return {
        text: "Privacy Policy",
        link: t
      };
    case "ja":
      return {
        text: "プライバシーポリシー",
        link: t
      };
    default:
      return le();
  }
}, er = (e) => {
  const t = "/terms";
  switch (e) {
    case "en":
      return {
        text: "Terms of Use",
        link: t
      };
    case "ja":
      return {
        text: "利用規約",
        link: t
      };
    default:
      return le();
  }
}, oo = {
  primary: "#EB7C06",
  primaryVariant: "#F0A14E",
  variant: "#FFD184",
  sub: "#F2EBDF",
  subVariant: "#FFFCF6",
  text: "#362E2B",
  subText: "#8E7E78",
  white: "#FFFFFF",
  background: "#FAF9F7"
}, ja = Ne`
  display: flex;
  flex: none;
  flex-direction: row;
  flex-grow: 0;
  gap: 10px;
  align-items: center;
  order: 1;
  width: fit-content;
  padding: 7px 20px;
  cursor: pointer;
  border-radius: 4px;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  &:hover {
    opacity: 0.8;
  }
`, Ra = Ne`
  flex: none;
  flex-grow: 0;
  order: 1;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  color: ${oo.sub};
  &:hover {
    opacity: 0.8;
  }
`, Aa = {
  default: "767px"
}, j = {
  buttonBase: ja,
  buttonText: Ra,
  colors: oo,
  mediaQuerySize: Aa
}, Da = b.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`, Pa = b.div`
  display: flex;
  flex: none;
  flex-direction: row;
  flex-grow: 0;
  align-items: center;
  justify-content: center;
  order: 0;
  width: 100%;
  padding: 10px 0 20px;
  background: ${j.colors.subVariant};
`, Ma = b.div`
  flex: none;
  flex-grow: 0;
  order: 1;
  width: 34px;
  height: 28px;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  color: #43281e;
  text-align: center;
`, ka = b.div`
  display: flex;
  flex: none;
  flex-direction: row;
  flex-grow: 0;
  gap: 10px;
  align-items: center;
  justify-content: center;
  order: 1;
  width: 100%;
  padding: 20px 0;
  background: ${j.colors.sub};
`, Fa = b.div`
  flex: none;
  flex-grow: 0;
  order: 0;
  width: 152px;
  height: 28px;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  color: #43281e;
`, $a = {
  flex: "none",
  flexGrow: "0",
  order: "0",
  height: "28px",
  fontFamily: "Roboto, sans-serif",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "28px",
  color: "#43281e",
  textAlign: "center",
  textDecorationLine: "underline",
  cursor: "pointer"
}, La = {
  flex: "none",
  flexGrow: "0",
  order: "2",
  height: "28px",
  fontFamily: "Roboto, sans-serif",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "28px",
  color: "#43281e",
  textAlign: "center",
  textDecorationLine: "underline",
  cursor: "pointer"
}, Ia = ({ language: e }) => {
  const t = er(e), r = Dt(e);
  return /* @__PURE__ */ l.jsxs(Da, { children: [
    /* @__PURE__ */ l.jsxs(Pa, { children: [
      /* @__PURE__ */ l.jsx(Oe, { href: t.link, prefetch: !1, style: $a, children: /* @__PURE__ */ l.jsx("p", { "data-gtm-click": "footer-terms-link", children: t.text }) }),
      /* @__PURE__ */ l.jsx(Ma, { children: " / " }),
      /* @__PURE__ */ l.jsx(Oe, { href: r.link, prefetch: !1, style: La, children: /* @__PURE__ */ l.jsx("p", { "data-gtm-click": "footer-privacy-link", children: r.text }) })
    ] }),
    /* @__PURE__ */ l.jsx(ka, { children: /* @__PURE__ */ l.jsx(Fa, { children: "Copyright (c) nekochans" }) })
  ] });
};
var ao = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, fn = _e.createContext && _e.createContext(ao), Ve = globalThis && globalThis.__assign || function() {
  return Ve = Object.assign || function(e) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var a in t)
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, Ve.apply(this, arguments);
}, Na = globalThis && globalThis.__rest || function(e, t) {
  var r = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
      t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
};
function io(e) {
  return e && e.map(function(t, r) {
    return _e.createElement(t.tag, Ve({
      key: r
    }, t.attr), io(t.child));
  });
}
function We(e) {
  return function(t) {
    return _e.createElement(Wa, Ve({
      attr: Ve({}, e.attr)
    }, t), io(e.child));
  };
}
function Wa(e) {
  var t = function(r) {
    var n = e.attr, a = e.size, i = e.title, u = Na(e, ["attr", "size", "title"]), o = a || r.size || "1em", f;
    return r.className && (f = r.className), e.className && (f = (f ? f + " " : "") + e.className), _e.createElement("svg", Ve({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, r.attr, n, u, {
      className: f,
      style: Ve(Ve({
        color: e.color || r.color
      }, r.style), e.style),
      height: o,
      width: o,
      xmlns: "http://www.w3.org/2000/svg"
    }), i && _e.createElement("title", null, i), e.children);
  };
  return fn !== void 0 ? _e.createElement(fn.Consumer, null, function(r) {
    return t(r);
  }) : t(ao);
}
function pr(e) {
  return We({ tag: "svg", attr: { viewBox: "0 0 256 512" }, child: [{ tag: "path", attr: { d: "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z" } }] })(e);
}
function Ua(e) {
  return We({ tag: "svg", attr: { viewBox: "0 0 448 512" }, child: [{ tag: "path", attr: { d: "M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z" } }] })(e);
}
function za(e) {
  return We({ tag: "svg", attr: { viewBox: "0 0 320 512" }, child: [{ tag: "path", attr: { d: "M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z" } }] })(e);
}
function Br(e) {
  return We({ tag: "svg", attr: { viewBox: "0 0 640 512" }, child: [{ tag: "path", attr: { d: "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zM393.4 288H328v112c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V288h-65.4c-14.3 0-21.4-17.2-11.3-27.3l105.4-105.4c6.2-6.2 16.4-6.2 22.6 0l105.4 105.4c10.1 10.1 2.9 27.3-11.3 27.3z" } }] })(e);
}
function Ba(e) {
  return We({ tag: "svg", attr: { viewBox: "0 0 576 512" }, child: [{ tag: "path", attr: { d: "M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z" } }] })(e);
}
function Ha(e) {
  return We({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M504.971 359.029c9.373 9.373 9.373 24.569 0 33.941l-80 79.984c-15.01 15.01-40.971 4.49-40.971-16.971V416h-58.785a12.004 12.004 0 0 1-8.773-3.812l-70.556-75.596 53.333-57.143L352 336h32v-39.981c0-21.438 25.943-31.998 40.971-16.971l80 79.981zM12 176h84l52.781 56.551 53.333-57.143-70.556-75.596A11.999 11.999 0 0 0 122.785 96H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12zm372 0v39.984c0 21.46 25.961 31.98 40.971 16.971l80-79.984c9.373-9.373 9.373-24.569 0-33.941l-80-79.981C409.943 24.021 384 34.582 384 56.019V96h-58.785a12.004 12.004 0 0 0-8.773 3.812L96 336H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h110.785c3.326 0 6.503-1.381 8.773-3.812L352 176h32z" } }] })(e);
}
function Va(e) {
  return We({ tag: "svg", attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { d: "M370.72 133.28C339.458 104.008 298.888 87.962 255.848 88c-77.458.068-144.328 53.178-162.791 126.85-1.344 5.363-6.122 9.15-11.651 9.15H24.103c-7.498 0-13.194-6.807-11.807-14.176C33.933 94.924 134.813 8 256 8c66.448 0 126.791 26.136 171.315 68.685L463.03 40.97C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.749zM32 296h134.059c21.382 0 32.09 25.851 16.971 40.971l-41.75 41.75c31.262 29.273 71.835 45.319 114.876 45.28 77.418-.07 144.315-53.144 162.787-126.849 1.344-5.363 6.122-9.15 11.651-9.15h57.304c7.498 0 13.194 6.807 11.807 14.176C478.067 417.076 377.187 504 256 504c-66.448 0-126.791-26.136-171.315-68.685L48.97 471.03C33.851 486.149 8 475.441 8 454.059V320c0-13.255 10.745-24 24-24z" } }] })(e);
}
function qa(e) {
  return We({ tag: "svg", attr: { viewBox: "0 0 352 512" }, child: [{ tag: "path", attr: { d: "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z" } }] })(e);
}
var zt = {}, Ya = {
  get exports() {
    return zt;
  },
  set exports(e) {
    zt = e;
  }
}, rt = {}, ie = {}, dn = {
  get exports() {
    return ie;
  },
  set exports(e) {
    ie = e;
  }
}, Bt = {}, Ga = {
  get exports() {
    return Bt;
  },
  set exports(e) {
    Bt = e;
  }
}, se = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var pn;
function Ka() {
  if (pn)
    return se;
  pn = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, u = e ? Symbol.for("react.provider") : 60109, o = e ? Symbol.for("react.context") : 60110, f = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, p = e ? Symbol.for("react.suspense") : 60113, v = e ? Symbol.for("react.suspense_list") : 60120, w = e ? Symbol.for("react.memo") : 60115, O = e ? Symbol.for("react.lazy") : 60116, y = e ? Symbol.for("react.block") : 60121, D = e ? Symbol.for("react.fundamental") : 60117, W = e ? Symbol.for("react.responder") : 60118, X = e ? Symbol.for("react.scope") : 60119;
  function H(E) {
    if (typeof E == "object" && E !== null) {
      var Z = E.$$typeof;
      switch (Z) {
        case t:
          switch (E = E.type, E) {
            case f:
            case c:
            case n:
            case i:
            case a:
            case p:
              return E;
            default:
              switch (E = E && E.$$typeof, E) {
                case o:
                case d:
                case O:
                case w:
                case u:
                  return E;
                default:
                  return Z;
              }
          }
        case r:
          return Z;
      }
    }
  }
  function U(E) {
    return H(E) === c;
  }
  return se.AsyncMode = f, se.ConcurrentMode = c, se.ContextConsumer = o, se.ContextProvider = u, se.Element = t, se.ForwardRef = d, se.Fragment = n, se.Lazy = O, se.Memo = w, se.Portal = r, se.Profiler = i, se.StrictMode = a, se.Suspense = p, se.isAsyncMode = function(E) {
    return U(E) || H(E) === f;
  }, se.isConcurrentMode = U, se.isContextConsumer = function(E) {
    return H(E) === o;
  }, se.isContextProvider = function(E) {
    return H(E) === u;
  }, se.isElement = function(E) {
    return typeof E == "object" && E !== null && E.$$typeof === t;
  }, se.isForwardRef = function(E) {
    return H(E) === d;
  }, se.isFragment = function(E) {
    return H(E) === n;
  }, se.isLazy = function(E) {
    return H(E) === O;
  }, se.isMemo = function(E) {
    return H(E) === w;
  }, se.isPortal = function(E) {
    return H(E) === r;
  }, se.isProfiler = function(E) {
    return H(E) === i;
  }, se.isStrictMode = function(E) {
    return H(E) === a;
  }, se.isSuspense = function(E) {
    return H(E) === p;
  }, se.isValidElementType = function(E) {
    return typeof E == "string" || typeof E == "function" || E === n || E === c || E === i || E === a || E === p || E === v || typeof E == "object" && E !== null && (E.$$typeof === O || E.$$typeof === w || E.$$typeof === u || E.$$typeof === o || E.$$typeof === d || E.$$typeof === D || E.$$typeof === W || E.$$typeof === X || E.$$typeof === y);
  }, se.typeOf = H, se;
}
var ce = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hn;
function Qa() {
  return hn || (hn = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, u = e ? Symbol.for("react.provider") : 60109, o = e ? Symbol.for("react.context") : 60110, f = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, p = e ? Symbol.for("react.suspense") : 60113, v = e ? Symbol.for("react.suspense_list") : 60120, w = e ? Symbol.for("react.memo") : 60115, O = e ? Symbol.for("react.lazy") : 60116, y = e ? Symbol.for("react.block") : 60121, D = e ? Symbol.for("react.fundamental") : 60117, W = e ? Symbol.for("react.responder") : 60118, X = e ? Symbol.for("react.scope") : 60119;
    function H(M) {
      return typeof M == "string" || typeof M == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      M === n || M === c || M === i || M === a || M === p || M === v || typeof M == "object" && M !== null && (M.$$typeof === O || M.$$typeof === w || M.$$typeof === u || M.$$typeof === o || M.$$typeof === d || M.$$typeof === D || M.$$typeof === W || M.$$typeof === X || M.$$typeof === y);
    }
    function U(M) {
      if (typeof M == "object" && M !== null) {
        var xe = M.$$typeof;
        switch (xe) {
          case t:
            var ke = M.type;
            switch (ke) {
              case f:
              case c:
              case n:
              case i:
              case a:
              case p:
                return ke;
              default:
                var Pe = ke && ke.$$typeof;
                switch (Pe) {
                  case o:
                  case d:
                  case O:
                  case w:
                  case u:
                    return Pe;
                  default:
                    return xe;
                }
            }
          case r:
            return xe;
        }
      }
    }
    var E = f, Z = c, oe = o, ue = u, I = t, z = d, B = n, re = O, te = w, A = r, k = i, Y = a, h = p, N = !1;
    function L(M) {
      return N || (N = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), m(M) || U(M) === f;
    }
    function m(M) {
      return U(M) === c;
    }
    function _(M) {
      return U(M) === o;
    }
    function T(M) {
      return U(M) === u;
    }
    function x(M) {
      return typeof M == "object" && M !== null && M.$$typeof === t;
    }
    function g(M) {
      return U(M) === d;
    }
    function R(M) {
      return U(M) === n;
    }
    function C(M) {
      return U(M) === O;
    }
    function P(M) {
      return U(M) === w;
    }
    function V(M) {
      return U(M) === r;
    }
    function J(M) {
      return U(M) === i;
    }
    function Q(M) {
      return U(M) === a;
    }
    function ve(M) {
      return U(M) === p;
    }
    ce.AsyncMode = E, ce.ConcurrentMode = Z, ce.ContextConsumer = oe, ce.ContextProvider = ue, ce.Element = I, ce.ForwardRef = z, ce.Fragment = B, ce.Lazy = re, ce.Memo = te, ce.Portal = A, ce.Profiler = k, ce.StrictMode = Y, ce.Suspense = h, ce.isAsyncMode = L, ce.isConcurrentMode = m, ce.isContextConsumer = _, ce.isContextProvider = T, ce.isElement = x, ce.isForwardRef = g, ce.isFragment = R, ce.isLazy = C, ce.isMemo = P, ce.isPortal = V, ce.isProfiler = J, ce.isStrictMode = Q, ce.isSuspense = ve, ce.isValidElementType = H, ce.typeOf = U;
  }()), ce;
}
var vn;
function so() {
  return vn || (vn = 1, function(e) {
    process.env.NODE_ENV === "production" ? e.exports = Ka() : e.exports = Qa();
  }(Ga)), Bt;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var hr, mn;
function Ja() {
  if (mn)
    return hr;
  mn = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function n(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var u = {}, o = 0; o < 10; o++)
        u["_" + String.fromCharCode(o)] = o;
      var f = Object.getOwnPropertyNames(u).map(function(d) {
        return u[d];
      });
      if (f.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(d) {
        c[d] = d;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return hr = a() ? Object.assign : function(i, u) {
    for (var o, f = n(i), c, d = 1; d < arguments.length; d++) {
      o = Object(arguments[d]);
      for (var p in o)
        t.call(o, p) && (f[p] = o[p]);
      if (e) {
        c = e(o);
        for (var v = 0; v < c.length; v++)
          r.call(o, c[v]) && (f[c[v]] = o[c[v]]);
      }
    }
    return f;
  }, hr;
}
var vr, gn;
function Hr() {
  if (gn)
    return vr;
  gn = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return vr = e, vr;
}
var mr, yn;
function co() {
  return yn || (yn = 1, mr = Function.call.bind(Object.prototype.hasOwnProperty)), mr;
}
var gr, xn;
function Xa() {
  if (xn)
    return gr;
  xn = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = Hr(), r = {}, n = co();
    e = function(i) {
      var u = "Warning: " + i;
      typeof console < "u" && console.error(u);
      try {
        throw new Error(u);
      } catch {
      }
    };
  }
  function a(i, u, o, f, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var d in i)
        if (n(i, d)) {
          var p;
          try {
            if (typeof i[d] != "function") {
              var v = Error(
                (f || "React class") + ": " + o + " type `" + d + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[d] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw v.name = "Invariant Violation", v;
            }
            p = i[d](u, d, f, o, null, t);
          } catch (O) {
            p = O;
          }
          if (p && !(p instanceof Error) && e(
            (f || "React class") + ": type specification of " + o + " `" + d + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof p + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), p instanceof Error && !(p.message in r)) {
            r[p.message] = !0;
            var w = c ? c() : "";
            e(
              "Failed " + o + " type: " + p.message + (w ?? "")
            );
          }
        }
    }
  }
  return a.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (r = {});
  }, gr = a, gr;
}
var yr, bn;
function Za() {
  if (bn)
    return yr;
  bn = 1;
  var e = so(), t = Ja(), r = Hr(), n = co(), a = Xa(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(o) {
    var f = "Warning: " + o;
    typeof console < "u" && console.error(f);
    try {
      throw new Error(f);
    } catch {
    }
  });
  function u() {
    return null;
  }
  return yr = function(o, f) {
    var c = typeof Symbol == "function" && Symbol.iterator, d = "@@iterator";
    function p(m) {
      var _ = m && (c && m[c] || m[d]);
      if (typeof _ == "function")
        return _;
    }
    var v = "<<anonymous>>", w = {
      array: W("array"),
      bigint: W("bigint"),
      bool: W("boolean"),
      func: W("function"),
      number: W("number"),
      object: W("object"),
      string: W("string"),
      symbol: W("symbol"),
      any: X(),
      arrayOf: H,
      element: U(),
      elementType: E(),
      instanceOf: Z,
      node: z(),
      objectOf: ue,
      oneOf: oe,
      oneOfType: I,
      shape: re,
      exact: te
    };
    function O(m, _) {
      return m === _ ? m !== 0 || 1 / m === 1 / _ : m !== m && _ !== _;
    }
    function y(m, _) {
      this.message = m, this.data = _ && typeof _ == "object" ? _ : {}, this.stack = "";
    }
    y.prototype = Error.prototype;
    function D(m) {
      if (process.env.NODE_ENV !== "production")
        var _ = {}, T = 0;
      function x(R, C, P, V, J, Q, ve) {
        if (V = V || v, Q = Q || P, ve !== r) {
          if (f) {
            var M = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw M.name = "Invariant Violation", M;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var xe = V + ":" + P;
            !_[xe] && // Avoid spamming the console because they are often not actionable except for lib authors
            T < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + Q + "` prop on `" + V + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), _[xe] = !0, T++);
          }
        }
        return C[P] == null ? R ? C[P] === null ? new y("The " + J + " `" + Q + "` is marked as required " + ("in `" + V + "`, but its value is `null`.")) : new y("The " + J + " `" + Q + "` is marked as required in " + ("`" + V + "`, but its value is `undefined`.")) : null : m(C, P, V, J, Q);
      }
      var g = x.bind(null, !1);
      return g.isRequired = x.bind(null, !0), g;
    }
    function W(m) {
      function _(T, x, g, R, C, P) {
        var V = T[x], J = Y(V);
        if (J !== m) {
          var Q = h(V);
          return new y(
            "Invalid " + R + " `" + C + "` of type " + ("`" + Q + "` supplied to `" + g + "`, expected ") + ("`" + m + "`."),
            { expectedType: m }
          );
        }
        return null;
      }
      return D(_);
    }
    function X() {
      return D(u);
    }
    function H(m) {
      function _(T, x, g, R, C) {
        if (typeof m != "function")
          return new y("Property `" + C + "` of component `" + g + "` has invalid PropType notation inside arrayOf.");
        var P = T[x];
        if (!Array.isArray(P)) {
          var V = Y(P);
          return new y("Invalid " + R + " `" + C + "` of type " + ("`" + V + "` supplied to `" + g + "`, expected an array."));
        }
        for (var J = 0; J < P.length; J++) {
          var Q = m(P, J, g, R, C + "[" + J + "]", r);
          if (Q instanceof Error)
            return Q;
        }
        return null;
      }
      return D(_);
    }
    function U() {
      function m(_, T, x, g, R) {
        var C = _[T];
        if (!o(C)) {
          var P = Y(C);
          return new y("Invalid " + g + " `" + R + "` of type " + ("`" + P + "` supplied to `" + x + "`, expected a single ReactElement."));
        }
        return null;
      }
      return D(m);
    }
    function E() {
      function m(_, T, x, g, R) {
        var C = _[T];
        if (!e.isValidElementType(C)) {
          var P = Y(C);
          return new y("Invalid " + g + " `" + R + "` of type " + ("`" + P + "` supplied to `" + x + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return D(m);
    }
    function Z(m) {
      function _(T, x, g, R, C) {
        if (!(T[x] instanceof m)) {
          var P = m.name || v, V = L(T[x]);
          return new y("Invalid " + R + " `" + C + "` of type " + ("`" + V + "` supplied to `" + g + "`, expected ") + ("instance of `" + P + "`."));
        }
        return null;
      }
      return D(_);
    }
    function oe(m) {
      if (!Array.isArray(m))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), u;
      function _(T, x, g, R, C) {
        for (var P = T[x], V = 0; V < m.length; V++)
          if (O(P, m[V]))
            return null;
        var J = JSON.stringify(m, function(ve, M) {
          var xe = h(M);
          return xe === "symbol" ? String(M) : M;
        });
        return new y("Invalid " + R + " `" + C + "` of value `" + String(P) + "` " + ("supplied to `" + g + "`, expected one of " + J + "."));
      }
      return D(_);
    }
    function ue(m) {
      function _(T, x, g, R, C) {
        if (typeof m != "function")
          return new y("Property `" + C + "` of component `" + g + "` has invalid PropType notation inside objectOf.");
        var P = T[x], V = Y(P);
        if (V !== "object")
          return new y("Invalid " + R + " `" + C + "` of type " + ("`" + V + "` supplied to `" + g + "`, expected an object."));
        for (var J in P)
          if (n(P, J)) {
            var Q = m(P, J, g, R, C + "." + J, r);
            if (Q instanceof Error)
              return Q;
          }
        return null;
      }
      return D(_);
    }
    function I(m) {
      if (!Array.isArray(m))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), u;
      for (var _ = 0; _ < m.length; _++) {
        var T = m[_];
        if (typeof T != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + N(T) + " at index " + _ + "."
          ), u;
      }
      function x(g, R, C, P, V) {
        for (var J = [], Q = 0; Q < m.length; Q++) {
          var ve = m[Q], M = ve(g, R, C, P, V, r);
          if (M == null)
            return null;
          M.data && n(M.data, "expectedType") && J.push(M.data.expectedType);
        }
        var xe = J.length > 0 ? ", expected one of type [" + J.join(", ") + "]" : "";
        return new y("Invalid " + P + " `" + V + "` supplied to " + ("`" + C + "`" + xe + "."));
      }
      return D(x);
    }
    function z() {
      function m(_, T, x, g, R) {
        return A(_[T]) ? null : new y("Invalid " + g + " `" + R + "` supplied to " + ("`" + x + "`, expected a ReactNode."));
      }
      return D(m);
    }
    function B(m, _, T, x, g) {
      return new y(
        (m || "React class") + ": " + _ + " type `" + T + "." + x + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + g + "`."
      );
    }
    function re(m) {
      function _(T, x, g, R, C) {
        var P = T[x], V = Y(P);
        if (V !== "object")
          return new y("Invalid " + R + " `" + C + "` of type `" + V + "` " + ("supplied to `" + g + "`, expected `object`."));
        for (var J in m) {
          var Q = m[J];
          if (typeof Q != "function")
            return B(g, R, C, J, h(Q));
          var ve = Q(P, J, g, R, C + "." + J, r);
          if (ve)
            return ve;
        }
        return null;
      }
      return D(_);
    }
    function te(m) {
      function _(T, x, g, R, C) {
        var P = T[x], V = Y(P);
        if (V !== "object")
          return new y("Invalid " + R + " `" + C + "` of type `" + V + "` " + ("supplied to `" + g + "`, expected `object`."));
        var J = t({}, T[x], m);
        for (var Q in J) {
          var ve = m[Q];
          if (n(m, Q) && typeof ve != "function")
            return B(g, R, C, Q, h(ve));
          if (!ve)
            return new y(
              "Invalid " + R + " `" + C + "` key `" + Q + "` supplied to `" + g + "`.\nBad object: " + JSON.stringify(T[x], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(m), null, "  ")
            );
          var M = ve(P, Q, g, R, C + "." + Q, r);
          if (M)
            return M;
        }
        return null;
      }
      return D(_);
    }
    function A(m) {
      switch (typeof m) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !m;
        case "object":
          if (Array.isArray(m))
            return m.every(A);
          if (m === null || o(m))
            return !0;
          var _ = p(m);
          if (_) {
            var T = _.call(m), x;
            if (_ !== m.entries) {
              for (; !(x = T.next()).done; )
                if (!A(x.value))
                  return !1;
            } else
              for (; !(x = T.next()).done; ) {
                var g = x.value;
                if (g && !A(g[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function k(m, _) {
      return m === "symbol" ? !0 : _ ? _["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && _ instanceof Symbol : !1;
    }
    function Y(m) {
      var _ = typeof m;
      return Array.isArray(m) ? "array" : m instanceof RegExp ? "object" : k(_, m) ? "symbol" : _;
    }
    function h(m) {
      if (typeof m > "u" || m === null)
        return "" + m;
      var _ = Y(m);
      if (_ === "object") {
        if (m instanceof Date)
          return "date";
        if (m instanceof RegExp)
          return "regexp";
      }
      return _;
    }
    function N(m) {
      var _ = h(m);
      switch (_) {
        case "array":
        case "object":
          return "an " + _;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + _;
        default:
          return _;
      }
    }
    function L(m) {
      return !m.constructor || !m.constructor.name ? v : m.constructor.name;
    }
    return w.checkPropTypes = a, w.resetWarningCache = a.resetWarningCache, w.PropTypes = w, w;
  }, yr;
}
var xr, wn;
function ei() {
  if (wn)
    return xr;
  wn = 1;
  var e = Hr();
  function t() {
  }
  function r() {
  }
  return r.resetWarningCache = t, xr = function() {
    function n(u, o, f, c, d, p) {
      if (p !== e) {
        var v = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw v.name = "Invariant Violation", v;
      }
    }
    n.isRequired = n;
    function a() {
      return n;
    }
    var i = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: a,
      element: n,
      elementType: n,
      instanceOf: a,
      node: n,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: r,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, xr;
}
if (process.env.NODE_ENV !== "production") {
  var ti = so(), ri = !0;
  dn.exports = Za()(ti.isElement, ri);
} else
  dn.exports = ei()();
var Ht = {}, ni = {
  get exports() {
    return Ht;
  },
  set exports(e) {
    Ht = e;
  }
}, Ae = {}, Ct = {}, oi = {
  get exports() {
    return Ct;
  },
  set exports(e) {
    Ct = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = d;
  /*!
   * Adapted from jQuery UI core
   *
   * http://jqueryui.com
   *
   * Copyright 2014 jQuery Foundation and other contributors
   * Released under the MIT license.
   * http://jquery.org/license
   *
   * http://api.jqueryui.com/category/ui-core/
   */
  var r = "none", n = "contents", a = /input|select|textarea|button|object|iframe/;
  function i(p, v) {
    return v.getPropertyValue("overflow") !== "visible" || // if 'overflow: visible' set, check if there is actually any overflow
    p.scrollWidth <= 0 && p.scrollHeight <= 0;
  }
  function u(p) {
    var v = p.offsetWidth <= 0 && p.offsetHeight <= 0;
    if (v && !p.innerHTML)
      return !0;
    try {
      var w = window.getComputedStyle(p), O = w.getPropertyValue("display");
      return v ? O !== n && i(p, w) : O === r;
    } catch {
      return console.warn("Failed to inspect element style"), !1;
    }
  }
  function o(p) {
    for (var v = p, w = p.getRootNode && p.getRootNode(); v && v !== document.body; ) {
      if (w && v === w && (v = w.host.parentNode), u(v))
        return !1;
      v = v.parentNode;
    }
    return !0;
  }
  function f(p, v) {
    var w = p.nodeName.toLowerCase(), O = a.test(w) && !p.disabled || w === "a" && p.href || v;
    return O && o(p);
  }
  function c(p) {
    var v = p.getAttribute("tabindex");
    v === null && (v = void 0);
    var w = isNaN(v);
    return (w || v >= 0) && f(p, !w);
  }
  function d(p) {
    var v = [].slice.call(p.querySelectorAll("*"), 0).reduce(function(w, O) {
      return w.concat(O.shadowRoot ? d(O.shadowRoot) : [O]);
    }, []);
    return v.filter(c);
  }
  e.exports = t.default;
})(oi, Ct);
Object.defineProperty(Ae, "__esModule", {
  value: !0
});
Ae.resetState = ci;
Ae.log = li;
Ae.handleBlur = jt;
Ae.handleFocus = Rt;
Ae.markForFocusLater = ui;
Ae.returnFocus = fi;
Ae.popWithoutFocus = di;
Ae.setupScopedFocus = pi;
Ae.teardownScopedFocus = hi;
var ai = Ct, ii = si(ai);
function si(e) {
  return e && e.__esModule ? e : { default: e };
}
var nt = [], lt = null, Rr = !1;
function ci() {
  nt = [];
}
function li() {
  process.env.NODE_ENV !== "production" && (console.log("focusManager ----------"), nt.forEach(function(e) {
    var t = e || {};
    console.log(t.nodeName, t.className, t.id);
  }), console.log("end focusManager ----------"));
}
function jt() {
  Rr = !0;
}
function Rt() {
  if (Rr) {
    if (Rr = !1, !lt)
      return;
    setTimeout(function() {
      if (!lt.contains(document.activeElement)) {
        var e = (0, ii.default)(lt)[0] || lt;
        e.focus();
      }
    }, 0);
  }
}
function ui() {
  nt.push(document.activeElement);
}
function fi() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, t = null;
  try {
    nt.length !== 0 && (t = nt.pop(), t.focus({ preventScroll: e }));
    return;
  } catch {
    console.warn(["You tried to return focus to", t, "but it is not in the DOM anymore"].join(" "));
  }
}
function di() {
  nt.length > 0 && nt.pop();
}
function pi(e) {
  lt = e, window.addEventListener ? (window.addEventListener("blur", jt, !1), document.addEventListener("focus", Rt, !0)) : (window.attachEvent("onBlur", jt), document.attachEvent("onFocus", Rt));
}
function hi() {
  lt = null, window.addEventListener ? (window.removeEventListener("blur", jt), document.removeEventListener("focus", Rt)) : (window.detachEvent("onBlur", jt), document.detachEvent("onFocus", Rt));
}
var Vt = {}, vi = {
  get exports() {
    return Vt;
  },
  set exports(e) {
    Vt = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = u;
  var r = Ct, n = a(r);
  function a(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function i() {
    var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
    return o.activeElement.shadowRoot ? i(o.activeElement.shadowRoot) : o.activeElement;
  }
  function u(o, f) {
    var c = (0, n.default)(o);
    if (!c.length) {
      f.preventDefault();
      return;
    }
    var d = void 0, p = f.shiftKey, v = c[0], w = c[c.length - 1], O = i();
    if (o === O) {
      if (!p)
        return;
      d = w;
    }
    if (w === O && !p && (d = v), v === O && p && (d = w), d) {
      f.preventDefault(), d.focus();
      return;
    }
    var y = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent), D = y != null && y[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
    if (D) {
      var W = c.indexOf(O);
      if (W > -1 && (W += p ? -1 : 1), d = c[W], typeof d > "u") {
        f.preventDefault(), d = p ? w : v, d.focus();
        return;
      }
      f.preventDefault(), d.focus();
    }
  }
  e.exports = t.default;
})(vi, Vt);
var De = {}, mi = process.env.NODE_ENV !== "production", lo = function() {
};
if (mi) {
  var gi = function(t, r) {
    var n = arguments.length;
    r = new Array(n > 1 ? n - 1 : 0);
    for (var a = 1; a < n; a++)
      r[a - 1] = arguments[a];
    var i = 0, u = "Warning: " + t.replace(/%s/g, function() {
      return r[i++];
    });
    typeof console < "u" && console.error(u);
    try {
      throw new Error(u);
    } catch {
    }
  };
  lo = function(e, t, r) {
    var n = arguments.length;
    r = new Array(n > 2 ? n - 2 : 0);
    for (var a = 2; a < n; a++)
      r[a - 2] = arguments[a];
    if (t === void 0)
      throw new Error(
        "`warning(condition, format, ...args)` requires a warning message argument"
      );
    e || gi.apply(null, [t].concat(r));
  };
}
var yi = lo, Re = {}, Ar = {}, xi = {
  get exports() {
    return Ar;
  },
  set exports(e) {
    Ar = e;
  }
};
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
(function(e) {
  (function() {
    var t = !!(typeof window < "u" && window.document && window.document.createElement), r = {
      canUseDOM: t,
      canUseWorkers: typeof Worker < "u",
      canUseEventListeners: t && !!(window.addEventListener || window.attachEvent),
      canUseViewport: t && !!window.screen
    };
    e.exports ? e.exports = r : window.ExecutionEnvironment = r;
  })();
})(xi);
Object.defineProperty(Re, "__esModule", {
  value: !0
});
Re.canUseDOM = Re.SafeNodeList = Re.SafeHTMLCollection = void 0;
var bi = Ar, wi = Ei(bi);
function Ei(e) {
  return e && e.__esModule ? e : { default: e };
}
var tr = wi.default, _i = tr.canUseDOM ? window.HTMLElement : {};
Re.SafeHTMLCollection = tr.canUseDOM ? window.HTMLCollection : {};
Re.SafeNodeList = tr.canUseDOM ? window.NodeList : {};
Re.canUseDOM = tr.canUseDOM;
Re.default = _i;
Object.defineProperty(De, "__esModule", {
  value: !0
});
De.resetState = ji;
De.log = Ri;
De.assertNodeList = uo;
De.setElement = Ai;
De.validateElement = Vr;
De.hide = Di;
De.show = Pi;
De.documentNotReadyOrSSRTesting = Mi;
var Si = yi, Oi = Ci(Si), Ti = Re;
function Ci(e) {
  return e && e.__esModule ? e : { default: e };
}
var Se = null;
function ji() {
  Se && (Se.removeAttribute ? Se.removeAttribute("aria-hidden") : Se.length != null ? Se.forEach(function(e) {
    return e.removeAttribute("aria-hidden");
  }) : document.querySelectorAll(Se).forEach(function(e) {
    return e.removeAttribute("aria-hidden");
  })), Se = null;
}
function Ri() {
  if (process.env.NODE_ENV !== "production") {
    var e = Se || {};
    console.log("ariaAppHider ----------"), console.log(e.nodeName, e.className, e.id), console.log("end ariaAppHider ----------");
  }
}
function uo(e, t) {
  if (!e || !e.length)
    throw new Error("react-modal: No elements were found for selector " + t + ".");
}
function Ai(e) {
  var t = e;
  if (typeof t == "string" && Ti.canUseDOM) {
    var r = document.querySelectorAll(t);
    uo(r, t), t = r;
  }
  return Se = t || Se, Se;
}
function Vr(e) {
  var t = e || Se;
  return t ? Array.isArray(t) || t instanceof HTMLCollection || t instanceof NodeList ? t : [t] : ((0, Oi.default)(!1, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" ")), []);
}
function Di(e) {
  var t = !0, r = !1, n = void 0;
  try {
    for (var a = Vr(e)[Symbol.iterator](), i; !(t = (i = a.next()).done); t = !0) {
      var u = i.value;
      u.setAttribute("aria-hidden", "true");
    }
  } catch (o) {
    r = !0, n = o;
  } finally {
    try {
      !t && a.return && a.return();
    } finally {
      if (r)
        throw n;
    }
  }
}
function Pi(e) {
  var t = !0, r = !1, n = void 0;
  try {
    for (var a = Vr(e)[Symbol.iterator](), i; !(t = (i = a.next()).done); t = !0) {
      var u = i.value;
      u.removeAttribute("aria-hidden");
    }
  } catch (o) {
    r = !0, n = o;
  } finally {
    try {
      !t && a.return && a.return();
    } finally {
      if (r)
        throw n;
    }
  }
}
function Mi() {
  Se = null;
}
var ut = {};
Object.defineProperty(ut, "__esModule", {
  value: !0
});
ut.resetState = ki;
ut.log = Fi;
var Ze = {}, et = {};
function En(e, t) {
  e.classList.remove(t);
}
function ki() {
  var e = document.getElementsByTagName("html")[0];
  for (var t in Ze)
    En(e, Ze[t]);
  var r = document.body;
  for (var n in et)
    En(r, et[n]);
  Ze = {}, et = {};
}
function Fi() {
  if (process.env.NODE_ENV !== "production") {
    var e = document.getElementsByTagName("html")[0].className, t = `Show tracked classes:

`;
    t += "<html /> (" + e + `):
  `;
    for (var r in Ze)
      t += "  " + r + " " + Ze[r] + `
  `;
    e = document.body.className, t += `

doc.body (` + e + `):
  `;
    for (var n in et)
      t += "  " + n + " " + et[n] + `
  `;
    t += `
`, console.log(t);
  }
}
var $i = function(t, r) {
  return t[r] || (t[r] = 0), t[r] += 1, r;
}, Li = function(t, r) {
  return t[r] && (t[r] -= 1), r;
}, Ii = function(t, r, n) {
  n.forEach(function(a) {
    $i(r, a), t.add(a);
  });
}, Ni = function(t, r, n) {
  n.forEach(function(a) {
    Li(r, a), r[a] === 0 && t.remove(a);
  });
};
ut.add = function(t, r) {
  return Ii(t.classList, t.nodeName.toLowerCase() == "html" ? Ze : et, r.split(" "));
};
ut.remove = function(t, r) {
  return Ni(t.classList, t.nodeName.toLowerCase() == "html" ? Ze : et, r.split(" "));
};
var ft = {};
Object.defineProperty(ft, "__esModule", {
  value: !0
});
ft.log = Ui;
ft.resetState = zi;
function Wi(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
var fo = function e() {
  var t = this;
  Wi(this, e), this.register = function(r) {
    if (t.openInstances.indexOf(r) !== -1) {
      process.env.NODE_ENV !== "production" && console.warn("React-Modal: Cannot register modal instance that's already open");
      return;
    }
    t.openInstances.push(r), t.emit("register");
  }, this.deregister = function(r) {
    var n = t.openInstances.indexOf(r);
    if (n === -1) {
      process.env.NODE_ENV !== "production" && console.warn("React-Modal: Unable to deregister " + r + " as it was never registered");
      return;
    }
    t.openInstances.splice(n, 1), t.emit("deregister");
  }, this.subscribe = function(r) {
    t.subscribers.push(r);
  }, this.emit = function(r) {
    t.subscribers.forEach(function(n) {
      return n(
        r,
        // shallow copy to avoid accidental mutation
        t.openInstances.slice()
      );
    });
  }, this.openInstances = [], this.subscribers = [];
}, qt = new fo();
function Ui() {
  console.log("portalOpenInstances ----------"), console.log(qt.openInstances.length), qt.openInstances.forEach(function(e) {
    return console.log(e);
  }), console.log("end portalOpenInstances ----------");
}
function zi() {
  qt = new fo();
}
ft.default = qt;
var qr = {};
Object.defineProperty(qr, "__esModule", {
  value: !0
});
qr.resetState = qi;
qr.log = Yi;
var Bi = ft, Hi = Vi(Bi);
function Vi(e) {
  return e && e.__esModule ? e : { default: e };
}
var ye = void 0, je = void 0, tt = [];
function qi() {
  for (var e = [ye, je], t = 0; t < e.length; t++) {
    var r = e[t];
    r && r.parentNode && r.parentNode.removeChild(r);
  }
  ye = je = null, tt = [];
}
function Yi() {
  console.log("bodyTrap ----------"), console.log(tt.length);
  for (var e = [ye, je], t = 0; t < e.length; t++) {
    var r = e[t], n = r || {};
    console.log(n.nodeName, n.className, n.id);
  }
  console.log("edn bodyTrap ----------");
}
function _n() {
  if (tt.length === 0) {
    process.env.NODE_ENV !== "production" && console.warn("React-Modal: Open instances > 0 expected");
    return;
  }
  tt[tt.length - 1].focusContent();
}
function Gi(e, t) {
  !ye && !je && (ye = document.createElement("div"), ye.setAttribute("data-react-modal-body-trap", ""), ye.style.position = "absolute", ye.style.opacity = "0", ye.setAttribute("tabindex", "0"), ye.addEventListener("focus", _n), je = ye.cloneNode(), je.addEventListener("focus", _n)), tt = t, tt.length > 0 ? (document.body.firstChild !== ye && document.body.insertBefore(ye, document.body.firstChild), document.body.lastChild !== je && document.body.appendChild(je)) : (ye.parentElement && ye.parentElement.removeChild(ye), je.parentElement && je.parentElement.removeChild(je));
}
Hi.default.subscribe(Gi);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = Object.assign || function(A) {
    for (var k = 1; k < arguments.length; k++) {
      var Y = arguments[k];
      for (var h in Y)
        Object.prototype.hasOwnProperty.call(Y, h) && (A[h] = Y[h]);
    }
    return A;
  }, n = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(A) {
    return typeof A;
  } : function(A) {
    return A && typeof Symbol == "function" && A.constructor === Symbol && A !== Symbol.prototype ? "symbol" : typeof A;
  }, a = function() {
    function A(k, Y) {
      for (var h = 0; h < Y.length; h++) {
        var N = Y[h];
        N.enumerable = N.enumerable || !1, N.configurable = !0, "value" in N && (N.writable = !0), Object.defineProperty(k, N.key, N);
      }
    }
    return function(k, Y, h) {
      return Y && A(k.prototype, Y), h && A(k, h), k;
    };
  }(), i = _e, u = ie, o = E(u), f = Ae, c = U(f), d = Vt, p = E(d), v = De, w = U(v), O = ut, y = U(O), D = Re, W = E(D), X = ft, H = E(X);
  function U(A) {
    if (A && A.__esModule)
      return A;
    var k = {};
    if (A != null)
      for (var Y in A)
        Object.prototype.hasOwnProperty.call(A, Y) && (k[Y] = A[Y]);
    return k.default = A, k;
  }
  function E(A) {
    return A && A.__esModule ? A : { default: A };
  }
  function Z(A, k) {
    if (!(A instanceof k))
      throw new TypeError("Cannot call a class as a function");
  }
  function oe(A, k) {
    if (!A)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return k && (typeof k == "object" || typeof k == "function") ? k : A;
  }
  function ue(A, k) {
    if (typeof k != "function" && k !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof k);
    A.prototype = Object.create(k && k.prototype, { constructor: { value: A, enumerable: !1, writable: !0, configurable: !0 } }), k && (Object.setPrototypeOf ? Object.setPrototypeOf(A, k) : A.__proto__ = k);
  }
  var I = {
    overlay: "ReactModal__Overlay",
    content: "ReactModal__Content"
  }, z = function(k) {
    return k.code === "Tab" || k.keyCode === 9;
  }, B = function(k) {
    return k.code === "Escape" || k.keyCode === 27;
  }, re = 0, te = function(A) {
    ue(k, A);
    function k(Y) {
      Z(this, k);
      var h = oe(this, (k.__proto__ || Object.getPrototypeOf(k)).call(this, Y));
      return h.setOverlayRef = function(N) {
        h.overlay = N, h.props.overlayRef && h.props.overlayRef(N);
      }, h.setContentRef = function(N) {
        h.content = N, h.props.contentRef && h.props.contentRef(N);
      }, h.afterClose = function() {
        var N = h.props, L = N.appElement, m = N.ariaHideApp, _ = N.htmlOpenClassName, T = N.bodyOpenClassName, x = N.parentSelector, g = x && x().ownerDocument || document;
        T && y.remove(g.body, T), _ && y.remove(g.getElementsByTagName("html")[0], _), m && re > 0 && (re -= 1, re === 0 && w.show(L)), h.props.shouldFocusAfterRender && (h.props.shouldReturnFocusAfterClose ? (c.returnFocus(h.props.preventScroll), c.teardownScopedFocus()) : c.popWithoutFocus()), h.props.onAfterClose && h.props.onAfterClose(), H.default.deregister(h);
      }, h.open = function() {
        h.beforeOpen(), h.state.afterOpen && h.state.beforeClose ? (clearTimeout(h.closeTimer), h.setState({ beforeClose: !1 })) : (h.props.shouldFocusAfterRender && (c.setupScopedFocus(h.node), c.markForFocusLater()), h.setState({ isOpen: !0 }, function() {
          h.openAnimationFrame = requestAnimationFrame(function() {
            h.setState({ afterOpen: !0 }), h.props.isOpen && h.props.onAfterOpen && h.props.onAfterOpen({
              overlayEl: h.overlay,
              contentEl: h.content
            });
          });
        }));
      }, h.close = function() {
        h.props.closeTimeoutMS > 0 ? h.closeWithTimeout() : h.closeWithoutTimeout();
      }, h.focusContent = function() {
        return h.content && !h.contentHasFocus() && h.content.focus({ preventScroll: !0 });
      }, h.closeWithTimeout = function() {
        var N = Date.now() + h.props.closeTimeoutMS;
        h.setState({ beforeClose: !0, closesAt: N }, function() {
          h.closeTimer = setTimeout(h.closeWithoutTimeout, h.state.closesAt - Date.now());
        });
      }, h.closeWithoutTimeout = function() {
        h.setState({
          beforeClose: !1,
          isOpen: !1,
          afterOpen: !1,
          closesAt: null
        }, h.afterClose);
      }, h.handleKeyDown = function(N) {
        z(N) && (0, p.default)(h.content, N), h.props.shouldCloseOnEsc && B(N) && (N.stopPropagation(), h.requestClose(N));
      }, h.handleOverlayOnClick = function(N) {
        h.shouldClose === null && (h.shouldClose = !0), h.shouldClose && h.props.shouldCloseOnOverlayClick && (h.ownerHandlesClose() ? h.requestClose(N) : h.focusContent()), h.shouldClose = null;
      }, h.handleContentOnMouseUp = function() {
        h.shouldClose = !1;
      }, h.handleOverlayOnMouseDown = function(N) {
        !h.props.shouldCloseOnOverlayClick && N.target == h.overlay && N.preventDefault();
      }, h.handleContentOnClick = function() {
        h.shouldClose = !1;
      }, h.handleContentOnMouseDown = function() {
        h.shouldClose = !1;
      }, h.requestClose = function(N) {
        return h.ownerHandlesClose() && h.props.onRequestClose(N);
      }, h.ownerHandlesClose = function() {
        return h.props.onRequestClose;
      }, h.shouldBeClosed = function() {
        return !h.state.isOpen && !h.state.beforeClose;
      }, h.contentHasFocus = function() {
        return document.activeElement === h.content || h.content.contains(document.activeElement);
      }, h.buildClassName = function(N, L) {
        var m = (typeof L > "u" ? "undefined" : n(L)) === "object" ? L : {
          base: I[N],
          afterOpen: I[N] + "--after-open",
          beforeClose: I[N] + "--before-close"
        }, _ = m.base;
        return h.state.afterOpen && (_ = _ + " " + m.afterOpen), h.state.beforeClose && (_ = _ + " " + m.beforeClose), typeof L == "string" && L ? _ + " " + L : _;
      }, h.attributesFromObject = function(N, L) {
        return Object.keys(L).reduce(function(m, _) {
          return m[N + "-" + _] = L[_], m;
        }, {});
      }, h.state = {
        afterOpen: !1,
        beforeClose: !1
      }, h.shouldClose = null, h.moveFromContentToOverlay = null, h;
    }
    return a(k, [{
      key: "componentDidMount",
      value: function() {
        this.props.isOpen && this.open();
      }
    }, {
      key: "componentDidUpdate",
      value: function(h, N) {
        process.env.NODE_ENV !== "production" && (h.bodyOpenClassName !== this.props.bodyOpenClassName && console.warn('React-Modal: "bodyOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.'), h.htmlOpenClassName !== this.props.htmlOpenClassName && console.warn('React-Modal: "htmlOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.')), this.props.isOpen && !h.isOpen ? this.open() : !this.props.isOpen && h.isOpen && this.close(), this.props.shouldFocusAfterRender && this.state.isOpen && !N.isOpen && this.focusContent();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.state.isOpen && this.afterClose(), clearTimeout(this.closeTimer), cancelAnimationFrame(this.openAnimationFrame);
      }
    }, {
      key: "beforeOpen",
      value: function() {
        var h = this.props, N = h.appElement, L = h.ariaHideApp, m = h.htmlOpenClassName, _ = h.bodyOpenClassName, T = h.parentSelector, x = T && T().ownerDocument || document;
        _ && y.add(x.body, _), m && y.add(x.getElementsByTagName("html")[0], m), L && (re += 1, w.hide(N)), H.default.register(this);
      }
      // Don't steal focus from inner elements
    }, {
      key: "render",
      value: function() {
        var h = this.props, N = h.id, L = h.className, m = h.overlayClassName, _ = h.defaultStyles, T = h.children, x = L ? {} : _.content, g = m ? {} : _.overlay;
        if (this.shouldBeClosed())
          return null;
        var R = {
          ref: this.setOverlayRef,
          className: this.buildClassName("overlay", m),
          style: r({}, g, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown
        }, C = r({
          id: N,
          ref: this.setContentRef,
          style: r({}, x, this.props.style.content),
          className: this.buildClassName("content", L),
          tabIndex: "-1",
          onKeyDown: this.handleKeyDown,
          onMouseDown: this.handleContentOnMouseDown,
          onMouseUp: this.handleContentOnMouseUp,
          onClick: this.handleContentOnClick,
          role: this.props.role,
          "aria-label": this.props.contentLabel
        }, this.attributesFromObject("aria", r({ modal: !0 }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
          "data-testid": this.props.testId
        }), P = this.props.contentElement(C, T);
        return this.props.overlayElement(R, P);
      }
    }]), k;
  }(i.Component);
  te.defaultProps = {
    style: {
      overlay: {},
      content: {}
    },
    defaultStyles: {}
  }, te.propTypes = {
    isOpen: o.default.bool.isRequired,
    defaultStyles: o.default.shape({
      content: o.default.object,
      overlay: o.default.object
    }),
    style: o.default.shape({
      content: o.default.object,
      overlay: o.default.object
    }),
    className: o.default.oneOfType([o.default.string, o.default.object]),
    overlayClassName: o.default.oneOfType([o.default.string, o.default.object]),
    parentSelector: o.default.func,
    bodyOpenClassName: o.default.string,
    htmlOpenClassName: o.default.string,
    ariaHideApp: o.default.bool,
    appElement: o.default.oneOfType([o.default.instanceOf(W.default), o.default.instanceOf(D.SafeHTMLCollection), o.default.instanceOf(D.SafeNodeList), o.default.arrayOf(o.default.instanceOf(W.default))]),
    onAfterOpen: o.default.func,
    onAfterClose: o.default.func,
    onRequestClose: o.default.func,
    closeTimeoutMS: o.default.number,
    shouldFocusAfterRender: o.default.bool,
    shouldCloseOnOverlayClick: o.default.bool,
    shouldReturnFocusAfterClose: o.default.bool,
    preventScroll: o.default.bool,
    role: o.default.string,
    contentLabel: o.default.string,
    aria: o.default.object,
    data: o.default.object,
    children: o.default.node,
    shouldCloseOnEsc: o.default.bool,
    overlayRef: o.default.func,
    contentRef: o.default.func,
    id: o.default.string,
    overlayElement: o.default.func,
    contentElement: o.default.func,
    testId: o.default.string
  }, t.default = te, e.exports = t.default;
})(ni, Ht);
function po() {
  var e = this.constructor.getDerivedStateFromProps(this.props, this.state);
  e != null && this.setState(e);
}
function ho(e) {
  function t(r) {
    var n = this.constructor.getDerivedStateFromProps(e, r);
    return n ?? null;
  }
  this.setState(t.bind(this));
}
function vo(e, t) {
  try {
    var r = this.props, n = this.state;
    this.props = e, this.state = t, this.__reactInternalSnapshotFlag = !0, this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      r,
      n
    );
  } finally {
    this.props = r, this.state = n;
  }
}
po.__suppressDeprecationWarning = !0;
ho.__suppressDeprecationWarning = !0;
vo.__suppressDeprecationWarning = !0;
function Ki(e) {
  var t = e.prototype;
  if (!t || !t.isReactComponent)
    throw new Error("Can only polyfill class components");
  if (typeof e.getDerivedStateFromProps != "function" && typeof t.getSnapshotBeforeUpdate != "function")
    return e;
  var r = null, n = null, a = null;
  if (typeof t.componentWillMount == "function" ? r = "componentWillMount" : typeof t.UNSAFE_componentWillMount == "function" && (r = "UNSAFE_componentWillMount"), typeof t.componentWillReceiveProps == "function" ? n = "componentWillReceiveProps" : typeof t.UNSAFE_componentWillReceiveProps == "function" && (n = "UNSAFE_componentWillReceiveProps"), typeof t.componentWillUpdate == "function" ? a = "componentWillUpdate" : typeof t.UNSAFE_componentWillUpdate == "function" && (a = "UNSAFE_componentWillUpdate"), r !== null || n !== null || a !== null) {
    var i = e.displayName || e.name, u = typeof e.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
    throw Error(
      `Unsafe legacy lifecycles will not be called for components using new component APIs.

` + i + " uses " + u + " but also contains the following legacy lifecycles:" + (r !== null ? `
  ` + r : "") + (n !== null ? `
  ` + n : "") + (a !== null ? `
  ` + a : "") + `

The above lifecycles should be removed. Learn more about this warning here:
https://fb.me/react-async-component-lifecycle-hooks`
    );
  }
  if (typeof e.getDerivedStateFromProps == "function" && (t.componentWillMount = po, t.componentWillReceiveProps = ho), typeof t.getSnapshotBeforeUpdate == "function") {
    if (typeof t.componentDidUpdate != "function")
      throw new Error(
        "Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype"
      );
    t.componentWillUpdate = vo;
    var o = t.componentDidUpdate;
    t.componentDidUpdate = function(c, d, p) {
      var v = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : p;
      o.call(this, c, d, v);
    };
  }
  return e;
}
const Qi = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  polyfill: Ki
}, Symbol.toStringTag, { value: "Module" })), Ji = /* @__PURE__ */ la(Qi);
Object.defineProperty(rt, "__esModule", {
  value: !0
});
rt.bodyOpenClassName = rt.portalClassName = void 0;
var Sn = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var n in r)
      Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
  }
  return e;
}, Xi = function() {
  function e(t, r) {
    for (var n = 0; n < r.length; n++) {
      var a = r[n];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, a.key, a);
    }
  }
  return function(t, r, n) {
    return r && e(t.prototype, r), n && e(t, n), t;
  };
}(), mo = _e, Yt = Pt(mo), Zi = Xo, Gt = Pt(Zi), es = ie, K = Pt(es), ts = Ht, On = Pt(ts), rs = De, ns = as(rs), He = Re, Tn = Pt(He), os = Ji;
function as(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var r in e)
      Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
  return t.default = e, t;
}
function Pt(e) {
  return e && e.__esModule ? e : { default: e };
}
function is(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Cn(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function ss(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var cs = rt.portalClassName = "ReactModalPortal", ls = rt.bodyOpenClassName = "ReactModal__Body--open", Ke = He.canUseDOM && Gt.default.createPortal !== void 0, Dr = function(t) {
  return document.createElement(t);
}, jn = function() {
  return Ke ? Gt.default.createPortal : Gt.default.unstable_renderSubtreeIntoContainer;
};
function $t(e) {
  return e();
}
var dt = function(e) {
  ss(t, e);
  function t() {
    var r, n, a, i;
    is(this, t);
    for (var u = arguments.length, o = Array(u), f = 0; f < u; f++)
      o[f] = arguments[f];
    return i = (n = (a = Cn(this, (r = t.__proto__ || Object.getPrototypeOf(t)).call.apply(r, [this].concat(o))), a), a.removePortal = function() {
      !Ke && Gt.default.unmountComponentAtNode(a.node);
      var c = $t(a.props.parentSelector);
      c && c.contains(a.node) ? c.removeChild(a.node) : console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.');
    }, a.portalRef = function(c) {
      a.portal = c;
    }, a.renderPortal = function(c) {
      var d = jn(), p = d(a, Yt.default.createElement(On.default, Sn({ defaultStyles: t.defaultStyles }, c)), a.node);
      a.portalRef(p);
    }, n), Cn(a, i);
  }
  return Xi(t, [{
    key: "componentDidMount",
    value: function() {
      if (He.canUseDOM) {
        Ke || (this.node = Dr("div")), this.node.className = this.props.portalClassName;
        var n = $t(this.props.parentSelector);
        n.appendChild(this.node), !Ke && this.renderPortal(this.props);
      }
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function(n) {
      var a = $t(n.parentSelector), i = $t(this.props.parentSelector);
      return { prevParent: a, nextParent: i };
    }
  }, {
    key: "componentDidUpdate",
    value: function(n, a, i) {
      if (He.canUseDOM) {
        var u = this.props, o = u.isOpen, f = u.portalClassName;
        n.portalClassName !== f && (this.node.className = f);
        var c = i.prevParent, d = i.nextParent;
        d !== c && (c.removeChild(this.node), d.appendChild(this.node)), !(!n.isOpen && !o) && !Ke && this.renderPortal(this.props);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      if (!(!He.canUseDOM || !this.node || !this.portal)) {
        var n = this.portal.state, a = Date.now(), i = n.isOpen && this.props.closeTimeoutMS && (n.closesAt || a + this.props.closeTimeoutMS);
        i ? (n.beforeClose || this.portal.closeWithTimeout(), setTimeout(this.removePortal, i - a)) : this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function() {
      if (!He.canUseDOM || !Ke)
        return null;
      !this.node && Ke && (this.node = Dr("div"));
      var n = jn();
      return n(Yt.default.createElement(On.default, Sn({
        ref: this.portalRef,
        defaultStyles: t.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function(n) {
      ns.setElement(n);
    }
    /* eslint-disable react/no-unused-prop-types */
    /* eslint-enable react/no-unused-prop-types */
  }]), t;
}(mo.Component);
dt.propTypes = {
  isOpen: K.default.bool.isRequired,
  style: K.default.shape({
    content: K.default.object,
    overlay: K.default.object
  }),
  portalClassName: K.default.string,
  bodyOpenClassName: K.default.string,
  htmlOpenClassName: K.default.string,
  className: K.default.oneOfType([K.default.string, K.default.shape({
    base: K.default.string.isRequired,
    afterOpen: K.default.string.isRequired,
    beforeClose: K.default.string.isRequired
  })]),
  overlayClassName: K.default.oneOfType([K.default.string, K.default.shape({
    base: K.default.string.isRequired,
    afterOpen: K.default.string.isRequired,
    beforeClose: K.default.string.isRequired
  })]),
  appElement: K.default.oneOfType([K.default.instanceOf(Tn.default), K.default.instanceOf(He.SafeHTMLCollection), K.default.instanceOf(He.SafeNodeList), K.default.arrayOf(K.default.instanceOf(Tn.default))]),
  onAfterOpen: K.default.func,
  onRequestClose: K.default.func,
  closeTimeoutMS: K.default.number,
  ariaHideApp: K.default.bool,
  shouldFocusAfterRender: K.default.bool,
  shouldCloseOnOverlayClick: K.default.bool,
  shouldReturnFocusAfterClose: K.default.bool,
  preventScroll: K.default.bool,
  parentSelector: K.default.func,
  aria: K.default.object,
  data: K.default.object,
  role: K.default.string,
  contentLabel: K.default.string,
  shouldCloseOnEsc: K.default.bool,
  overlayRef: K.default.func,
  contentRef: K.default.func,
  id: K.default.string,
  overlayElement: K.default.func,
  contentElement: K.default.func
};
dt.defaultProps = {
  isOpen: !1,
  portalClassName: cs,
  bodyOpenClassName: ls,
  role: "dialog",
  ariaHideApp: !0,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: !0,
  shouldCloseOnEsc: !0,
  shouldCloseOnOverlayClick: !0,
  shouldReturnFocusAfterClose: !0,
  preventScroll: !1,
  parentSelector: function() {
    return document.body;
  },
  overlayElement: function(t, r) {
    return Yt.default.createElement(
      "div",
      t,
      r
    );
  },
  contentElement: function(t, r) {
    return Yt.default.createElement(
      "div",
      t,
      r
    );
  }
};
dt.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};
(0, os.polyfill)(dt);
process.env.NODE_ENV !== "production" && (dt.setCreateHTMLElement = function(e) {
  return Dr = e;
});
rt.default = dt;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var r = rt, n = a(r);
  function a(i) {
    return i && i.__esModule ? i : { default: i };
  }
  t.default = n.default, e.exports = t.default;
})(Ya, zt);
const go = /* @__PURE__ */ Wr(zt), us = b.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
  justify-content: center;
  width: 69px;
  height: 35px;
  padding: 10px 22px 7px 0;
`, fs = b.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
  justify-content: center;
  padding: 10px 22px 7px 0;
`, ds = b.div`
  flex: none;
  flex-grow: 0;
  order: 0;
  width: 30px;
  height: 30px;
`, ps = {
  fontStyle: "normal",
  fontWeight: 900,
  fontSize: "30px",
  lineHeight: "30px",
  color: `${j.colors.primary}`,
  cursor: "pointer"
}, hs = b.div`
  position: absolute;
  top: 73px;
  left: 15px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 305px;
  height: 180px;
  padding: 0;
`, Lt = b.div`
  flex: none;
  flex-grow: 0;
  order: 0;
  width: 305px;
  height: 45px;
`, It = b.span`
  display: flex;
  align-items: center;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
  color: ${j.colors.primary};
  text-decoration-line: underline;
  cursor: pointer;
`, Nt = b.div`
  box-sizing: border-box;
  background: ${j.colors.background};
  border-bottom: 1px solid ${j.colors.sub};
`, vs = {
  fontStyle: "normal",
  fontWeight: 900,
  fontSize: "16px",
  lineHeight: "30px",
  color: `${j.colors.primary}`,
  marginRight: "10px"
}, ms = ({ language: e, onClickCloseButton: t }) => {
  const r = er(e), n = Dt(e);
  return /* @__PURE__ */ l.jsxs(us, { children: [
    /* @__PURE__ */ l.jsx(fs, { children: /* @__PURE__ */ l.jsx(ds, { onClick: t, children: /* @__PURE__ */ l.jsx(qa, { style: ps }) }) }),
    /* @__PURE__ */ l.jsxs(hs, { children: [
      /* @__PURE__ */ l.jsxs(Lt, { children: [
        /* @__PURE__ */ l.jsx(Oe, { href: "/", prefetch: !1, children: /* @__PURE__ */ l.jsx(It, { "data-gtm-click": "global-menu-top-link", children: "TOP" }) }),
        /* @__PURE__ */ l.jsx(Nt, {})
      ] }),
      /* @__PURE__ */ l.jsxs(Lt, { children: [
        /* @__PURE__ */ l.jsx(Oe, { href: "/upload", prefetch: !1, children: /* @__PURE__ */ l.jsxs(It, { "data-gtm-click": "global-menu-upload-cat-link", children: [
          /* @__PURE__ */ l.jsx(Br, { style: vs }),
          "Upload new Cats"
        ] }) }),
        /* @__PURE__ */ l.jsx(Nt, {})
      ] }),
      /* @__PURE__ */ l.jsxs(Lt, { children: [
        /* @__PURE__ */ l.jsx(Oe, { href: r.link, prefetch: !1, children: /* @__PURE__ */ l.jsx(It, { "data-gtm-click": "global-menu-terms-link", children: r.text }) }),
        /* @__PURE__ */ l.jsx(Nt, {})
      ] }),
      /* @__PURE__ */ l.jsxs(Lt, { children: [
        /* @__PURE__ */ l.jsx(Oe, { href: n.link, prefetch: !1, children: /* @__PURE__ */ l.jsx(It, { "data-gtm-click": "global-menu-terms-link", children: n.text }) }),
        /* @__PURE__ */ l.jsx(Nt, {})
      ] })
    ] })
  ] });
}, gs = b.div`
  @media (max-width: ${j.mediaQuerySize.default}) {
    padding: 12px 0;
  }
  box-sizing: border-box;
  display: flex;
  flex: none;
  flex-direction: row;
  flex-grow: 0;
  gap: 10px;
  align-items: center;
  justify-content: center;
  order: 1;
  padding: 12px 20px;
  border-radius: 4px;
`, ys = b.p`
  flex: none;
  flex-grow: 0;
  order: 0;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 19px;
  color: ${j.colors.primary};
  cursor: pointer;
`, xs = {
  color: `${j.colors.primary}`,
  cursor: "pointer"
}, bs = ({ onClick: e }) => /* @__PURE__ */ l.jsxs(gs, { onClick: e, children: [
  /* @__PURE__ */ l.jsx(ys, { children: "Language" }),
  /* @__PURE__ */ l.jsx(za, { style: xs })
] }), yo = Ne`
  display: flex;
  flex: none;
  flex-direction: row;
  flex-grow: 0;
  gap: 10px;
  align-items: flex-start;
  width: 125px;
  height: 39px;
  padding: 10px 0;
  background: rgba(54, 46, 43, 0.4);
`, ws = b.nav`
  @media (max-width: ${j.mediaQuerySize.default}) {
    right: 0;
  }
  position: absolute;
  right: 20px;
  bottom: -70px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
`, Es = b.span`
  ${yo};
  order: 0;
`, Rn = b.span`
  display: block;
  flex: none;
  flex-grow: 0;
  order: 0;
  width: 125px;
  height: 19px;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 19px;
  color: ${j.colors.background};
  text-align: center;
  cursor: pointer;
`, _s = b.span`
  flex: none;
  flex-grow: 0;
  order: 1;
  width: 125px;
  height: 0;
  border: 1px solid rgba(54, 46, 43, 0.5);
`, Ss = b.span`
  ${yo};
  order: 2;
`, Os = b.span`
  display: block;
  flex: none;
  flex-grow: 0;
  order: 0;
  width: 125px;
  height: 19px;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 19px;
  color: ${j.colors.background};
  text-align: center;
  text-decoration: none;
  cursor: pointer;
`, Ts = ({ language: e, currentUrlPath: t }) => /* @__PURE__ */ l.jsxs(ws, { children: [
  /* @__PURE__ */ l.jsxs(Es, { children: [
    /* @__PURE__ */ l.jsx(
      Oe,
      {
        href: t,
        locale: "en",
        style: { textDecoration: "none" },
        children: /* @__PURE__ */ l.jsxs(Rn, { "data-gtm-click": "language-menu-en-link", children: [
          e === "en" ? /* @__PURE__ */ l.jsx(pr, {}) : "",
          "English"
        ] })
      }
    ),
    /* @__PURE__ */ l.jsxs(Rn, { children: [
      e === "en" ? /* @__PURE__ */ l.jsx(pr, {}) : "",
      "English"
    ] })
  ] }),
  /* @__PURE__ */ l.jsx(_s, {}),
  /* @__PURE__ */ l.jsx(Ss, { children: /* @__PURE__ */ l.jsx(
    Oe,
    {
      href: t,
      locale: "ja",
      prefetch: !1,
      style: { textDecoration: "none" },
      children: /* @__PURE__ */ l.jsxs(Os, { "data-gtm-click": "language-menu-ja-link", children: [
        e === "ja" ? /* @__PURE__ */ l.jsx(pr, {}) : "",
        "日本語"
      ] })
    }
  ) })
] }), Cs = b.div`
  background: #e9e2d7;
`, js = b.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  max-width: 900px;
  padding: 12px 20px;
  margin: 0 auto;
`, Rs = b.span`
  position: absolute;
  top: 26.67%;
  bottom: 26.67%;
  left: 50%;
  font-family: Roboto, sans-serif;
  font-size: 21px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  color: #000;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  transform: translateX(-50%);
`, As = {
  width: "27px",
  height: "28px",
  fontStyle: "normal",
  fontWeight: 900,
  fontSize: "30px",
  lineHeight: "28px",
  color: `${j.colors.primary}`,
  flex: "none",
  order: 0,
  flexGrow: 0,
  cursor: "pointer"
}, Ds = {
  // stylelint-disable-next-line
  overlay: {
    background: "rgba(54, 46, 43, 0.7)"
  },
  content: {
    top: "0",
    left: "0",
    width: "365px",
    height: "100vh"
  }
}, Ps = ({
  language: e,
  isLanguageMenuDisplayed: t,
  onClickLanguageButton: r,
  currentUrlPath: n
}) => {
  const [a, i] = Ce(!1), u = () => {
    i(!0);
  }, o = () => {
    i(!1);
  };
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsx(
      go,
      {
        isOpen: a,
        ariaHideApp: !1,
        style: Ds,
        onRequestClose: o,
        children: /* @__PURE__ */ l.jsx(ms, { language: e, onClickCloseButton: o })
      }
    ),
    /* @__PURE__ */ l.jsx(Cs, { children: /* @__PURE__ */ l.jsxs(js, { children: [
      /* @__PURE__ */ l.jsx(Ua, { style: As, onClick: u }),
      /* @__PURE__ */ l.jsx(Oe, { href: "/", prefetch: !1, children: /* @__PURE__ */ l.jsx(Rs, { "data-gtm-click": "header-app-title", children: "LGTMeow" }) }),
      /* @__PURE__ */ l.jsx(bs, { onClick: r }),
      t ? /* @__PURE__ */ l.jsx(Ts, { language: e, currentUrlPath: n }) : ""
    ] }) })
  ] });
}, rr = "https://lgtmeow.com", xo = Ne`
  position: absolute;
  left: 50%;
  padding: 3%;
  color: ${j.colors.white};
  text-align: center;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 30px;
  transform: translate(-50%, 0);
`, Ms = b.div`
  ${xo};
  bottom: 30%;
`, ks = b.div`
  ${xo};
  top: 15%;
  opacity: 0.5;
`, nr = ({
  position: e = "default"
}) => {
  const t = "Github Markdown Copied!";
  return /* @__PURE__ */ l.jsx(l.Fragment, { children: e === "default" ? /* @__PURE__ */ l.jsx(Ms, { children: t }) : /* @__PURE__ */ l.jsx(ks, { children: t }) });
}, Fs = b.div`
  position: relative;
  height: 300px;
  cursor: pointer;
  &:hover {
    opacity: 0.7;
  }
`, $s = ({
  id: e,
  imageUrl: t,
  appUrl: r,
  callback: n
}) => {
  const { copied: a, onCopySuccess: i } = Zt(n), { imageContextRef: u } = Xt({
    onCopySuccess: i,
    imageUrl: t,
    appUrl: r ?? rr
  });
  return /* @__PURE__ */ l.jsxs(Fs, { ref: u, children: [
    /* @__PURE__ */ l.jsx(
      Zo,
      {
        src: t,
        style: { objectFit: "contain" },
        sizes: "100vw",
        fill: !0,
        alt: "lgtm-cat-image",
        priority: !0
      }
    ),
    a ? /* @__PURE__ */ l.jsx(nr, {}) : ""
  ] }, e);
}, Ls = b.div`
  @media (max-width: ${j.mediaQuerySize.default}) {
    grid-template-columns: 1fr;
    gap: 10px;
  }
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;
`, Is = ({ images: e, appUrl: t, callback: r }) => /* @__PURE__ */ l.jsx(Ls, { children: e.map((n) => /* @__PURE__ */ l.jsx(
  $s,
  {
    id: n.id,
    imageUrl: n.imageUrl,
    appUrl: t,
    callback: r
  },
  n.id
)) });
function pt(e, t, r, n) {
  function a(i) {
    return i instanceof r ? i : new r(function(u) {
      u(i);
    });
  }
  return new (r || (r = Promise))(function(i, u) {
    function o(d) {
      try {
        c(n.next(d));
      } catch (p) {
        u(p);
      }
    }
    function f(d) {
      try {
        c(n.throw(d));
      } catch (p) {
        u(p);
      }
    }
    function c(d) {
      d.done ? i(d.value) : a(d.value).then(o, f);
    }
    c((n = n.apply(e, t || [])).next());
  });
}
function ht(e, t) {
  var r = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, a, i, u;
  return u = { next: o(0), throw: o(1), return: o(2) }, typeof Symbol == "function" && (u[Symbol.iterator] = function() {
    return this;
  }), u;
  function o(c) {
    return function(d) {
      return f([c, d]);
    };
  }
  function f(c) {
    if (n)
      throw new TypeError("Generator is already executing.");
    for (; u && (u = 0, c[0] && (r = 0)), r; )
      try {
        if (n = 1, a && (i = c[0] & 2 ? a.return : c[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, c[1])).done)
          return i;
        switch (a = 0, i && (c = [c[0] & 2, i.value]), c[0]) {
          case 0:
          case 1:
            i = c;
            break;
          case 4:
            return r.label++, { value: c[1], done: !1 };
          case 5:
            r.label++, a = c[1], c = [0];
            continue;
          case 7:
            c = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (i = r.trys, !(i = i.length > 0 && i[i.length - 1]) && (c[0] === 6 || c[0] === 2)) {
              r = 0;
              continue;
            }
            if (c[0] === 3 && (!i || c[1] > i[0] && c[1] < i[3])) {
              r.label = c[1];
              break;
            }
            if (c[0] === 6 && r.label < i[1]) {
              r.label = i[1], i = c;
              break;
            }
            if (i && r.label < i[2]) {
              r.label = i[2], r.ops.push(c);
              break;
            }
            i[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        c = t.call(e, r);
      } catch (d) {
        c = [6, d], a = 0;
      } finally {
        n = i = 0;
      }
    if (c[0] & 5)
      throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}
function An(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), a, i = [], u;
  try {
    for (; (t === void 0 || t-- > 0) && !(a = n.next()).done; )
      i.push(a.value);
  } catch (o) {
    u = { error: o };
  } finally {
    try {
      a && !a.done && (r = n.return) && r.call(n);
    } finally {
      if (u)
        throw u.error;
    }
  }
  return i;
}
function Dn(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, a = t.length, i; n < a; n++)
      (i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var Ns = /* @__PURE__ */ new Map([
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
  ["aac", "audio/aac"],
  ["abw", "application/x-abiword"],
  ["arc", "application/x-freearc"],
  ["avif", "image/avif"],
  ["avi", "video/x-msvideo"],
  ["azw", "application/vnd.amazon.ebook"],
  ["bin", "application/octet-stream"],
  ["bmp", "image/bmp"],
  ["bz", "application/x-bzip"],
  ["bz2", "application/x-bzip2"],
  ["cda", "application/x-cdf"],
  ["csh", "application/x-csh"],
  ["css", "text/css"],
  ["csv", "text/csv"],
  ["doc", "application/msword"],
  ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  ["eot", "application/vnd.ms-fontobject"],
  ["epub", "application/epub+zip"],
  ["gz", "application/gzip"],
  ["gif", "image/gif"],
  ["heic", "image/heic"],
  ["heif", "image/heif"],
  ["htm", "text/html"],
  ["html", "text/html"],
  ["ico", "image/vnd.microsoft.icon"],
  ["ics", "text/calendar"],
  ["jar", "application/java-archive"],
  ["jpeg", "image/jpeg"],
  ["jpg", "image/jpeg"],
  ["js", "text/javascript"],
  ["json", "application/json"],
  ["jsonld", "application/ld+json"],
  ["mid", "audio/midi"],
  ["midi", "audio/midi"],
  ["mjs", "text/javascript"],
  ["mp3", "audio/mpeg"],
  ["mp4", "video/mp4"],
  ["mpeg", "video/mpeg"],
  ["mpkg", "application/vnd.apple.installer+xml"],
  ["odp", "application/vnd.oasis.opendocument.presentation"],
  ["ods", "application/vnd.oasis.opendocument.spreadsheet"],
  ["odt", "application/vnd.oasis.opendocument.text"],
  ["oga", "audio/ogg"],
  ["ogv", "video/ogg"],
  ["ogx", "application/ogg"],
  ["opus", "audio/opus"],
  ["otf", "font/otf"],
  ["png", "image/png"],
  ["pdf", "application/pdf"],
  ["php", "application/x-httpd-php"],
  ["ppt", "application/vnd.ms-powerpoint"],
  ["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
  ["rar", "application/vnd.rar"],
  ["rtf", "application/rtf"],
  ["sh", "application/x-sh"],
  ["svg", "image/svg+xml"],
  ["swf", "application/x-shockwave-flash"],
  ["tar", "application/x-tar"],
  ["tif", "image/tiff"],
  ["tiff", "image/tiff"],
  ["ts", "video/mp2t"],
  ["ttf", "font/ttf"],
  ["txt", "text/plain"],
  ["vsd", "application/vnd.visio"],
  ["wav", "audio/wav"],
  ["weba", "audio/webm"],
  ["webm", "video/webm"],
  ["webp", "image/webp"],
  ["woff", "font/woff"],
  ["woff2", "font/woff2"],
  ["xhtml", "application/xhtml+xml"],
  ["xls", "application/vnd.ms-excel"],
  ["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  ["xml", "application/xml"],
  ["xul", "application/vnd.mozilla.xul+xml"],
  ["zip", "application/zip"],
  ["7z", "application/x-7z-compressed"],
  // Others
  ["mkv", "video/x-matroska"],
  ["mov", "video/quicktime"],
  ["msg", "application/vnd.ms-outlook"]
]);
function Mt(e, t) {
  var r = Ws(e);
  if (typeof r.path != "string") {
    var n = e.webkitRelativePath;
    Object.defineProperty(r, "path", {
      value: typeof t == "string" ? t : typeof n == "string" && n.length > 0 ? n : e.name,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return r;
}
function Ws(e) {
  var t = e.name, r = t && t.lastIndexOf(".") !== -1;
  if (r && !e.type) {
    var n = t.split(".").pop().toLowerCase(), a = Ns.get(n);
    a && Object.defineProperty(e, "type", {
      value: a,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return e;
}
var Us = [
  // Thumbnail cache files for macOS and Windows
  ".DS_Store",
  "Thumbs.db"
  // Windows
];
function zs(e) {
  return pt(this, void 0, void 0, function() {
    return ht(this, function(t) {
      return Kt(e) && Bs(e.dataTransfer) ? [2, Ys(e.dataTransfer, e.type)] : Hs(e) ? [2, Vs(e)] : Array.isArray(e) && e.every(function(r) {
        return "getFile" in r && typeof r.getFile == "function";
      }) ? [2, qs(e)] : [2, []];
    });
  });
}
function Bs(e) {
  return Kt(e);
}
function Hs(e) {
  return Kt(e) && Kt(e.target);
}
function Kt(e) {
  return typeof e == "object" && e !== null;
}
function Vs(e) {
  return Pr(e.target.files).map(function(t) {
    return Mt(t);
  });
}
function qs(e) {
  return pt(this, void 0, void 0, function() {
    var t;
    return ht(this, function(r) {
      switch (r.label) {
        case 0:
          return [4, Promise.all(e.map(function(n) {
            return n.getFile();
          }))];
        case 1:
          return t = r.sent(), [2, t.map(function(n) {
            return Mt(n);
          })];
      }
    });
  });
}
function Ys(e, t) {
  return pt(this, void 0, void 0, function() {
    var r, n;
    return ht(this, function(a) {
      switch (a.label) {
        case 0:
          return e.items ? (r = Pr(e.items).filter(function(i) {
            return i.kind === "file";
          }), t !== "drop" ? [2, r] : [4, Promise.all(r.map(Gs))]) : [3, 2];
        case 1:
          return n = a.sent(), [2, Pn(bo(n))];
        case 2:
          return [2, Pn(Pr(e.files).map(function(i) {
            return Mt(i);
          }))];
      }
    });
  });
}
function Pn(e) {
  return e.filter(function(t) {
    return Us.indexOf(t.name) === -1;
  });
}
function Pr(e) {
  if (e === null)
    return [];
  for (var t = [], r = 0; r < e.length; r++) {
    var n = e[r];
    t.push(n);
  }
  return t;
}
function Gs(e) {
  if (typeof e.webkitGetAsEntry != "function")
    return Mn(e);
  var t = e.webkitGetAsEntry();
  return t && t.isDirectory ? wo(t) : Mn(e);
}
function bo(e) {
  return e.reduce(function(t, r) {
    return Dn(Dn([], An(t), !1), An(Array.isArray(r) ? bo(r) : [r]), !1);
  }, []);
}
function Mn(e) {
  var t = e.getAsFile();
  if (!t)
    return Promise.reject("".concat(e, " is not a File"));
  var r = Mt(t);
  return Promise.resolve(r);
}
function Ks(e) {
  return pt(this, void 0, void 0, function() {
    return ht(this, function(t) {
      return [2, e.isDirectory ? wo(e) : Qs(e)];
    });
  });
}
function wo(e) {
  var t = e.createReader();
  return new Promise(function(r, n) {
    var a = [];
    function i() {
      var u = this;
      t.readEntries(function(o) {
        return pt(u, void 0, void 0, function() {
          var f, c, d;
          return ht(this, function(p) {
            switch (p.label) {
              case 0:
                if (o.length)
                  return [3, 5];
                p.label = 1;
              case 1:
                return p.trys.push([1, 3, , 4]), [4, Promise.all(a)];
              case 2:
                return f = p.sent(), r(f), [3, 4];
              case 3:
                return c = p.sent(), n(c), [3, 4];
              case 4:
                return [3, 6];
              case 5:
                d = Promise.all(o.map(Ks)), a.push(d), i(), p.label = 6;
              case 6:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, function(o) {
        n(o);
      });
    }
    i();
  });
}
function Qs(e) {
  return pt(this, void 0, void 0, function() {
    return ht(this, function(t) {
      return [2, new Promise(function(r, n) {
        e.file(function(a) {
          var i = Mt(a, e.fullPath);
          r(i);
        }, function(a) {
          n(a);
        });
      })];
    });
  });
}
var Js = function(e, t) {
  if (e && t) {
    var r = Array.isArray(t) ? t : t.split(","), n = e.name || "", a = (e.type || "").toLowerCase(), i = a.replace(/\/.*$/, "");
    return r.some(function(u) {
      var o = u.trim().toLowerCase();
      return o.charAt(0) === "." ? n.toLowerCase().endsWith(o) : o.endsWith("/*") ? i === o.replace(/\/.*$/, "") : a === o;
    });
  }
  return !0;
};
function kn(e) {
  return ec(e) || Zs(e) || _o(e) || Xs();
}
function Xs() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Zs(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function ec(e) {
  if (Array.isArray(e))
    return Mr(e);
}
function Fn(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function $n(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Fn(Object(r), !0).forEach(function(n) {
      Eo(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Fn(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Eo(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function At(e, t) {
  return nc(e) || rc(e, t) || _o(e, t) || tc();
}
function tc() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _o(e, t) {
  if (e) {
    if (typeof e == "string")
      return Mr(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return Mr(e, t);
  }
}
function Mr(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function rc(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n = [], a = !0, i = !1, u, o;
    try {
      for (r = r.call(e); !(a = (u = r.next()).done) && (n.push(u.value), !(t && n.length === t)); a = !0)
        ;
    } catch (f) {
      i = !0, o = f;
    } finally {
      try {
        !a && r.return != null && r.return();
      } finally {
        if (i)
          throw o;
      }
    }
    return n;
  }
}
function nc(e) {
  if (Array.isArray(e))
    return e;
}
var oc = "file-invalid-type", ac = "file-too-large", ic = "file-too-small", sc = "too-many-files", cc = function(t) {
  t = Array.isArray(t) && t.length === 1 ? t[0] : t;
  var r = Array.isArray(t) ? "one of ".concat(t.join(", ")) : t;
  return {
    code: oc,
    message: "File type must be ".concat(r)
  };
}, Ln = function(t) {
  return {
    code: ac,
    message: "File is larger than ".concat(t, " ").concat(t === 1 ? "byte" : "bytes")
  };
}, In = function(t) {
  return {
    code: ic,
    message: "File is smaller than ".concat(t, " ").concat(t === 1 ? "byte" : "bytes")
  };
}, lc = {
  code: sc,
  message: "Too many files"
};
function So(e, t) {
  var r = e.type === "application/x-moz-file" || Js(e, t);
  return [r, r ? null : cc(t)];
}
function Oo(e, t, r) {
  if (Qe(e.size))
    if (Qe(t) && Qe(r)) {
      if (e.size > r)
        return [!1, Ln(r)];
      if (e.size < t)
        return [!1, In(t)];
    } else {
      if (Qe(t) && e.size < t)
        return [!1, In(t)];
      if (Qe(r) && e.size > r)
        return [!1, Ln(r)];
    }
  return [!0, null];
}
function Qe(e) {
  return e != null;
}
function uc(e) {
  var t = e.files, r = e.accept, n = e.minSize, a = e.maxSize, i = e.multiple, u = e.maxFiles, o = e.validator;
  return !i && t.length > 1 || i && u >= 1 && t.length > u ? !1 : t.every(function(f) {
    var c = So(f, r), d = At(c, 1), p = d[0], v = Oo(f, n, a), w = At(v, 1), O = w[0], y = o ? o(f) : null;
    return p && O && !y;
  });
}
function Qt(e) {
  return typeof e.isPropagationStopped == "function" ? e.isPropagationStopped() : typeof e.cancelBubble < "u" ? e.cancelBubble : !1;
}
function Wt(e) {
  return e.dataTransfer ? Array.prototype.some.call(e.dataTransfer.types, function(t) {
    return t === "Files" || t === "application/x-moz-file";
  }) : !!e.target && !!e.target.files;
}
function Nn(e) {
  e.preventDefault();
}
function fc(e) {
  return e.indexOf("MSIE") !== -1 || e.indexOf("Trident/") !== -1;
}
function dc(e) {
  return e.indexOf("Edge/") !== -1;
}
function pc() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
  return fc(e) || dc(e);
}
function Me() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return function(n) {
    for (var a = arguments.length, i = new Array(a > 1 ? a - 1 : 0), u = 1; u < a; u++)
      i[u - 1] = arguments[u];
    return t.some(function(o) {
      return !Qt(n) && o && o.apply(void 0, [n].concat(i)), Qt(n);
    });
  };
}
function hc() {
  return "showOpenFilePicker" in window;
}
function vc(e) {
  if (Qe(e)) {
    var t = Object.entries(e).filter(function(r) {
      var n = At(r, 2), a = n[0], i = n[1], u = !0;
      return To(a) || (console.warn('Skipped "'.concat(a, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.')), u = !1), (!Array.isArray(i) || !i.every(Co)) && (console.warn('Skipped "'.concat(a, '" because an invalid file extension was provided.')), u = !1), u;
    }).reduce(function(r, n) {
      var a = At(n, 2), i = a[0], u = a[1];
      return $n($n({}, r), {}, Eo({}, i, u));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: t
    }];
  }
  return e;
}
function mc(e) {
  if (Qe(e))
    return Object.entries(e).reduce(function(t, r) {
      var n = At(r, 2), a = n[0], i = n[1];
      return [].concat(kn(t), [a], kn(i));
    }, []).filter(function(t) {
      return To(t) || Co(t);
    }).join(",");
}
function gc(e) {
  return e instanceof DOMException && (e.name === "AbortError" || e.code === e.ABORT_ERR);
}
function yc(e) {
  return e instanceof DOMException && (e.name === "SecurityError" || e.code === e.SECURITY_ERR);
}
function To(e) {
  return e === "audio/*" || e === "video/*" || e === "image/*" || e === "text/*" || /\w+\/[-+.\w]+/g.test(e);
}
function Co(e) {
  return /^.*\.[\w]+$/.test(e);
}
var xc = ["children"], bc = ["open"], wc = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"], Ec = ["refKey", "onChange", "onClick"];
function _c(e) {
  return Tc(e) || Oc(e) || jo(e) || Sc();
}
function Sc() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Oc(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Tc(e) {
  if (Array.isArray(e))
    return kr(e);
}
function br(e, t) {
  return Rc(e) || jc(e, t) || jo(e, t) || Cc();
}
function Cc() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function jo(e, t) {
  if (e) {
    if (typeof e == "string")
      return kr(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set")
      return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return kr(e, t);
  }
}
function kr(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function jc(e, t) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var n = [], a = !0, i = !1, u, o;
    try {
      for (r = r.call(e); !(a = (u = r.next()).done) && (n.push(u.value), !(t && n.length === t)); a = !0)
        ;
    } catch (f) {
      i = !0, o = f;
    } finally {
      try {
        !a && r.return != null && r.return();
      } finally {
        if (i)
          throw o;
      }
    }
    return n;
  }
}
function Rc(e) {
  if (Array.isArray(e))
    return e;
}
function Wn(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function he(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Wn(Object(r), !0).forEach(function(n) {
      Fr(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Wn(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Fr(e, t, r) {
  return t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function Jt(e, t) {
  if (e == null)
    return {};
  var r = Ac(e, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      n = i[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Ac(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
var Yr = /* @__PURE__ */ Ko(function(e, t) {
  var r = e.children, n = Jt(e, xc), a = Ao(n), i = a.open, u = Jt(a, bc);
  return Qo(t, function() {
    return {
      open: i
    };
  }, [i]), /* @__PURE__ */ _e.createElement(Jo, null, r(he(he({}, u), {}, {
    open: i
  })));
});
Yr.displayName = "Dropzone";
var Ro = {
  disabled: !1,
  getFilesFromEvent: zs,
  maxSize: 1 / 0,
  minSize: 0,
  multiple: !0,
  maxFiles: 0,
  preventDropOnDocument: !0,
  noClick: !1,
  noKeyboard: !1,
  noDrag: !1,
  noDragEventsBubbling: !1,
  validator: null,
  useFsAccessApi: !0,
  autoFocus: !1
};
Yr.defaultProps = Ro;
Yr.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: ie.func,
  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: ie.objectOf(ie.arrayOf(ie.string)),
  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: ie.bool,
  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: ie.bool,
  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: ie.bool,
  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: ie.bool,
  /**
   * If true, disables drag 'n' drop
   */
  noDrag: ie.bool,
  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: ie.bool,
  /**
   * Minimum file size (in bytes)
   */
  minSize: ie.number,
  /**
   * Maximum file size (in bytes)
   */
  maxSize: ie.number,
  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: ie.number,
  /**
   * Enable/disable the dropzone
   */
  disabled: ie.bool,
  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: ie.func,
  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: ie.func,
  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: ie.func,
  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: ie.bool,
  /**
   * Set to true to focus the root element on render
   */
  autoFocus: ie.bool,
  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: ie.func,
  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: ie.func,
  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: ie.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: ie.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: ie.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: ie.func,
  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: ie.func,
  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: ie.func
};
var $r = {
  isFocused: !1,
  isFileDialogActive: !1,
  isDragActive: !1,
  isDragAccept: !1,
  isDragReject: !1,
  acceptedFiles: [],
  fileRejections: []
};
function Ao() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = he(he({}, Ro), e), r = t.accept, n = t.disabled, a = t.getFilesFromEvent, i = t.maxSize, u = t.minSize, o = t.multiple, f = t.maxFiles, c = t.onDragEnter, d = t.onDragLeave, p = t.onDragOver, v = t.onDrop, w = t.onDropAccepted, O = t.onDropRejected, y = t.onFileDialogCancel, D = t.onFileDialogOpen, W = t.useFsAccessApi, X = t.autoFocus, H = t.preventDropOnDocument, U = t.noClick, E = t.noKeyboard, Z = t.noDrag, oe = t.noDragEventsBubbling, ue = t.onError, I = t.validator, z = Ge(function() {
    return mc(r);
  }, [r]), B = Ge(function() {
    return vc(r);
  }, [r]), re = Ge(function() {
    return typeof D == "function" ? D : Un;
  }, [D]), te = Ge(function() {
    return typeof y == "function" ? y : Un;
  }, [y]), A = Be(null), k = Be(null), Y = Go(Dc, $r), h = br(Y, 2), N = h[0], L = h[1], m = N.isFocused, _ = N.isFileDialogActive, T = Be(typeof window < "u" && window.isSecureContext && W && hc()), x = function() {
    !T.current && _ && setTimeout(function() {
      if (k.current) {
        var q = k.current.files;
        q.length || (L({
          type: "closeDialog"
        }), te());
      }
    }, 300);
  };
  Je(function() {
    return window.addEventListener("focus", x, !1), function() {
      window.removeEventListener("focus", x, !1);
    };
  }, [k, _, te, T]);
  var g = Be([]), R = function(q) {
    A.current && A.current.contains(q.target) || (q.preventDefault(), g.current = []);
  };
  Je(function() {
    return H && (document.addEventListener("dragover", Nn, !1), document.addEventListener("drop", R, !1)), function() {
      H && (document.removeEventListener("dragover", Nn), document.removeEventListener("drop", R));
    };
  }, [A, H]), Je(function() {
    return !n && X && A.current && A.current.focus(), function() {
    };
  }, [A, X, n]);
  var C = Ee(function($) {
    ue ? ue($) : console.error($);
  }, [ue]), P = Ee(function($) {
    $.preventDefault(), $.persist(), at($), g.current = [].concat(_c(g.current), [$.target]), Wt($) && Promise.resolve(a($)).then(function(q) {
      if (!(Qt($) && !oe)) {
        var de = q.length, pe = de > 0 && uc({
          files: q,
          accept: z,
          minSize: u,
          maxSize: i,
          multiple: o,
          maxFiles: f,
          validator: I
        }), be = de > 0 && !pe;
        L({
          isDragAccept: pe,
          isDragReject: be,
          isDragActive: !0,
          type: "setDraggedFiles"
        }), c && c($);
      }
    }).catch(function(q) {
      return C(q);
    });
  }, [a, c, C, oe, z, u, i, o, f, I]), V = Ee(function($) {
    $.preventDefault(), $.persist(), at($);
    var q = Wt($);
    if (q && $.dataTransfer)
      try {
        $.dataTransfer.dropEffect = "copy";
      } catch {
      }
    return q && p && p($), !1;
  }, [p, oe]), J = Ee(function($) {
    $.preventDefault(), $.persist(), at($);
    var q = g.current.filter(function(pe) {
      return A.current && A.current.contains(pe);
    }), de = q.indexOf($.target);
    de !== -1 && q.splice(de, 1), g.current = q, !(q.length > 0) && (L({
      type: "setDraggedFiles",
      isDragActive: !1,
      isDragAccept: !1,
      isDragReject: !1
    }), Wt($) && d && d($));
  }, [A, d, oe]), Q = Ee(function($, q) {
    var de = [], pe = [];
    $.forEach(function(be) {
      var Ue = So(be, z), Le = br(Ue, 2), Ye = Le[0], mt = Le[1], gt = Oo(be, u, i), it = br(gt, 2), yt = it[0], xt = it[1], bt = I ? I(be) : null;
      if (Ye && yt && !bt)
        de.push(be);
      else {
        var wt = [mt, xt];
        bt && (wt = wt.concat(bt)), pe.push({
          file: be,
          errors: wt.filter(function(Et) {
            return Et;
          })
        });
      }
    }), (!o && de.length > 1 || o && f >= 1 && de.length > f) && (de.forEach(function(be) {
      pe.push({
        file: be,
        errors: [lc]
      });
    }), de.splice(0)), L({
      acceptedFiles: de,
      fileRejections: pe,
      type: "setFiles"
    }), v && v(de, pe, q), pe.length > 0 && O && O(pe, q), de.length > 0 && w && w(de, q);
  }, [L, o, z, u, i, f, v, w, O, I]), ve = Ee(function($) {
    $.preventDefault(), $.persist(), at($), g.current = [], Wt($) && Promise.resolve(a($)).then(function(q) {
      Qt($) && !oe || Q(q, $);
    }).catch(function(q) {
      return C(q);
    }), L({
      type: "reset"
    });
  }, [a, Q, C, oe]), M = Ee(function() {
    if (T.current) {
      L({
        type: "openDialog"
      }), re();
      var $ = {
        multiple: o,
        types: B
      };
      window.showOpenFilePicker($).then(function(q) {
        return a(q);
      }).then(function(q) {
        Q(q, null), L({
          type: "closeDialog"
        });
      }).catch(function(q) {
        gc(q) ? (te(q), L({
          type: "closeDialog"
        })) : yc(q) ? (T.current = !1, k.current ? (k.current.value = null, k.current.click()) : C(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."))) : C(q);
      });
      return;
    }
    k.current && (L({
      type: "openDialog"
    }), re(), k.current.value = null, k.current.click());
  }, [L, re, te, W, Q, C, B, o]), xe = Ee(function($) {
    !A.current || !A.current.isEqualNode($.target) || ($.key === " " || $.key === "Enter" || $.keyCode === 32 || $.keyCode === 13) && ($.preventDefault(), M());
  }, [A, M]), ke = Ee(function() {
    L({
      type: "focus"
    });
  }, []), Pe = Ee(function() {
    L({
      type: "blur"
    });
  }, []), qe = Ee(function() {
    U || (pc() ? setTimeout(M, 0) : M());
  }, [U, M]), Fe = function(q) {
    return n ? null : q;
  }, ot = function(q) {
    return E ? null : Fe(q);
  }, $e = function(q) {
    return Z ? null : Fe(q);
  }, at = function(q) {
    oe && q.stopPropagation();
  }, ar = Ge(function() {
    return function() {
      var $ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, q = $.refKey, de = q === void 0 ? "ref" : q, pe = $.role, be = $.onKeyDown, Ue = $.onFocus, Le = $.onBlur, Ye = $.onClick, mt = $.onDragEnter, gt = $.onDragOver, it = $.onDragLeave, yt = $.onDrop, xt = Jt($, wc);
      return he(he(Fr({
        onKeyDown: ot(Me(be, xe)),
        onFocus: ot(Me(Ue, ke)),
        onBlur: ot(Me(Le, Pe)),
        onClick: Fe(Me(Ye, qe)),
        onDragEnter: $e(Me(mt, P)),
        onDragOver: $e(Me(gt, V)),
        onDragLeave: $e(Me(it, J)),
        onDrop: $e(Me(yt, ve)),
        role: typeof pe == "string" && pe !== "" ? pe : "presentation"
      }, de, A), !n && !E ? {
        tabIndex: 0
      } : {}), xt);
    };
  }, [A, xe, ke, Pe, qe, P, V, J, ve, E, Z, n]), vt = Ee(function($) {
    $.stopPropagation();
  }, []), ir = Ge(function() {
    return function() {
      var $ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, q = $.refKey, de = q === void 0 ? "ref" : q, pe = $.onChange, be = $.onClick, Ue = Jt($, Ec), Le = Fr({
        accept: z,
        multiple: o,
        type: "file",
        style: {
          display: "none"
        },
        onChange: Fe(Me(pe, ve)),
        onClick: Fe(Me(be, vt)),
        tabIndex: -1
      }, de, k);
      return he(he({}, Le), Ue);
    };
  }, [k, r, o, ve, n]);
  return he(he({}, N), {}, {
    isFocused: m && !n,
    getRootProps: ar,
    getInputProps: ir,
    rootRef: A,
    inputRef: k,
    open: Fe(M)
  });
}
function Dc(e, t) {
  switch (t.type) {
    case "focus":
      return he(he({}, e), {}, {
        isFocused: !0
      });
    case "blur":
      return he(he({}, e), {}, {
        isFocused: !1
      });
    case "openDialog":
      return he(he({}, $r), {}, {
        isFileDialogActive: !0
      });
    case "closeDialog":
      return he(he({}, e), {}, {
        isFileDialogActive: !1
      });
    case "setDraggedFiles":
      return he(he({}, e), {}, {
        isDragActive: t.isDragActive,
        isDragAccept: t.isDragAccept,
        isDragReject: t.isDragReject
      });
    case "setFiles":
      return he(he({}, e), {}, {
        acceptedFiles: t.acceptedFiles,
        fileRejections: t.fileRejections
      });
    case "reset":
      return he({}, $r);
    default:
      return e;
  }
}
function Un() {
}
const Do = Ne`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: center;
  padding: 8px 20px;
  background: ${j.colors.primary};
  border-radius: 4px;
`, Po = Ne`
  &:hover {
    opacity: 0.8;
  }
`, Pc = b.button`
  ${Do};
  ${Po};
`, Mo = Ne`
  flex: none;
  flex-grow: 0;
  order: 0;
  width: 128px;
  height: 18px;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
  color: ${j.colors.white};
`, Mc = b.div`
  ${Mo};
  ${Po};
`, ko = Ne`
  opacity: 0.5;
`, kc = b.button`
  ${Do};
  ${ko};
`, Fc = b.div`
  ${Mo};
  ${ko};
`, zn = (e) => {
  switch (e) {
    case "ja":
      return "アップロードする";
    case "en":
      return "Upload";
    default:
      return le();
  }
}, $c = ({ language: e, disabled: t, onClick: r }) => t ? /* @__PURE__ */ l.jsx(kc, { type: "submit", disabled: t, onClick: r, children: /* @__PURE__ */ l.jsx(Fc, { children: zn(e) }) }) : /* @__PURE__ */ l.jsx(Pc, { type: "submit", disabled: t, onClick: r, children: /* @__PURE__ */ l.jsx(Mc, { children: zn(e) }) }), Lc = b.div`
  @media (max-width: ${j.mediaQuerySize.default}) {
    width: 380px;
  }
  box-sizing: border-box;
  display: flex;
  flex: none;
  flex-direction: column;
  flex-grow: 0;
  gap: 10px;
  align-items: center;
  order: 0;
  width: 498px;
  height: 154px;
  padding: 30px 0;
  background: #f7ede2;
  border: 1px solid ${j.colors.primary};
`, Ic = {
  width: "498px",
  height: "28px",
  fontStyle: "normal",
  fontWeight: 900,
  fontSize: "31px",
  lineHeight: "28px",
  color: `${j.colors.primary}`,
  flex: "none",
  order: 0,
  flexGrow: 0
}, Nc = b.span`
  @media (max-width: ${j.mediaQuerySize.default}) {
    width: 380px;
  }
  flex: none;
  flex-grow: 0;
  order: 1;
  width: 498px;
  height: 56px;
  font-family: Noto Sans JP, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  color: ${j.colors.primary};
  text-align: center;
`, Wc = ({ messages: e }) => /* @__PURE__ */ l.jsxs(Lc, { children: [
  /* @__PURE__ */ l.jsx(Ba, { style: Ic }),
  /* @__PURE__ */ l.jsx(Nc, { children: e.map((t, r) => /* @__PURE__ */ l.jsx("p", { children: t }, r)) })
] }), Uc = b.div`
  flex: none;
  flex-grow: 0;
  order: 1;
  width: 280px;
  height: 54px;
`, zc = b.div`
  width: 280px;
  height: 20px;
`, Bc = b.div`
  width: 92px;
  height: 18px;
  background: ${j.colors.primaryVariant};
`, Hc = b.div`
  box-sizing: border-box;
  width: 280px;
  height: 20px;
  background: ${j.colors.sub};
  border: 1px solid ${j.colors.subText};
`, Vc = b.p`
  width: 56px;
  height: 28px;
  font-family: Roboto, sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  color: ${j.colors.subText};
`, qc = (e) => {
  switch (e) {
    case "ja":
      return "送信中…";
    case "en":
      return "Uploading…";
    default:
      return le();
  }
}, Yc = ({ language: e }) => {
  const [i, u] = Ce(1);
  return Je(() => {
    const o = setInterval(() => {
      const f = i <= 279 ? i + 10 : 1;
      u(f);
    }, 200);
    return () => {
      clearInterval(o);
    };
  }, [i]), /* @__PURE__ */ l.jsxs(Uc, { children: [
    /* @__PURE__ */ l.jsx(zc, { children: /* @__PURE__ */ l.jsx(Hc, { children: /* @__PURE__ */ l.jsx(Bc, { style: { width: `${i}px` } }) }) }),
    /* @__PURE__ */ l.jsx(Vc, { children: qc(e) })
  ] });
}, Gc = b.div`
  display: flex;
  flex: none;
  flex-direction: row;
  flex-grow: 0;
  gap: 20px;
  align-items: center;
  justify-content: center;
  order: 1;
  padding: 0;
`, Kc = b.button`
  box-sizing: border-box;
  display: flex;
  flex: none;
  flex-direction: row;
  flex-grow: 0;
  gap: 10px;
  align-items: center;
  justify-content: center;
  order: 0;
  padding: 12px 20px;
  background: ${j.colors.background};
  border: 1px solid ${j.colors.subText};
  border-radius: 4px;
  &:hover {
    opacity: 0.8;
  }
`, Qc = b.div`
  flex: none;
  flex-grow: 0;
  order: 0;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 19px;
  color: ${j.colors.primaryVariant};
  &:hover {
    opacity: 0.8;
  }
`, Jc = b.button`
  display: flex;
  flex: none;
  flex-direction: row;
  flex-grow: 0;
  gap: 10px;
  align-items: center;
  justify-content: center;
  order: 1;
  padding: 7px 20px;
  background: ${j.colors.primary};
  border-radius: 4px;
  &:hover {
    opacity: 0.8;
  }
`, Xc = b.div`
  flex: none;
  flex-grow: 0;
  order: 0;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
  color: ${j.colors.white};
  &:hover {
    opacity: 0.8;
  }
`, Zc = (e) => {
  switch (e) {
    case "ja":
      return "キャンセル";
    case "en":
      return "cancel";
    default:
      return le();
  }
}, el = (e) => {
  switch (e) {
    case "ja":
      return "アップロード";
    case "en":
      return "upload";
    default:
      return le();
  }
}, tl = ({
  language: e,
  onClickUpload: t,
  onClickCancel: r
}) => /* @__PURE__ */ l.jsxs(Gc, { children: [
  /* @__PURE__ */ l.jsx(Kc, { onClick: r, children: /* @__PURE__ */ l.jsx(Qc, { children: Zc(e) }) }),
  /* @__PURE__ */ l.jsx(Jc, { onClick: t, children: /* @__PURE__ */ l.jsx(Xc, { children: el(e) }) })
] }), rl = b.div`
  flex: none;
  flex-grow: 0;
  order: 0;
`, nl = b.img`
  @media (max-width: ${j.mediaQuerySize.default}) {
    max-width: 355px;
  }
  flex: none;
  flex-grow: 0;
  order: 0;
  width: auto;
  height: 270px;
`, ol = ({
  imagePreviewUrl: e,
  createdLgtmImageUrl: t,
  appUrl: r,
  callback: n
}) => {
  const { copied: a, onCopySuccess: i } = Zt(n), { imageContextRef: u } = Xt({
    onCopySuccess: i,
    imageUrl: t,
    appUrl: r ?? rr
  });
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsx(rl, { ref: u, children: /* @__PURE__ */ l.jsx(nl, { src: e }) }),
    a ? /* @__PURE__ */ l.jsx(nr, {}) : ""
  ] });
}, al = b.div`
  display: flex;
  flex: none;
  flex-direction: column;
  flex-grow: 0;
  gap: 24px;
  align-items: center;
  order: 1;
  width: 399px;
  height: 261px;
  padding: 0;
`, il = b.div`
  flex: none;
  flex-grow: 0;
  order: 0;
  width: 244px;
  height: 28px;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  color: ${j.colors.primary};
`, sl = b.div`
  display: flex;
  flex: none;
  flex-direction: column;
  flex-grow: 0;
  gap: 4px;
  align-items: center;
  order: 1;
  width: 399px;
  height: 209px;
  padding: 0;
`, cl = b.div`
  flex: none;
  flex-grow: 0;
  order: 0;
  width: 332px;
  height: 75px;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 25px;
  color: ${j.colors.subText};
  text-align: center;
`, ll = b.div`
  display: flex;
  flex: none;
  flex-direction: column;
  flex-grow: 0;
  gap: 30px;
  align-items: center;
  order: 1;
  width: 399px;
  height: 130px;
  padding: 0;
`, ul = b.div`
  box-sizing: border-box;
  display: flex;
  flex: none;
  flex-direction: row;
  flex-grow: 0;
  gap: 10px;
  align-items: flex-start;
  justify-content: center;
  order: 0;
  width: 399px;
  height: 57px;
  padding: 9px 20px 8px;
  border: 1px solid ${j.colors.sub};
  border-radius: 3px;
`, fl = b.div`
  flex: none;
  flex-grow: 0;
  order: 0;
  width: 359px;
  height: 40px;
  font-family: Roboto, sans-serif;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: ${j.colors.subText};
`, dl = b.div`
  display: flex;
  flex: none;
  flex-direction: row;
  flex-grow: 0;
  gap: 20px;
  align-items: center;
  justify-content: center;
  order: 1;
  padding: 0;
`, pl = b.button`
  box-sizing: border-box;
  display: flex;
  flex: none;
  flex-direction: row;
  flex-grow: 0;
  gap: 10px;
  align-items: center;
  justify-content: center;
  order: 0;
  padding: 12px 20px;
  background: ${j.colors.background};
  border: 1px solid ${j.colors.subText};
  border-radius: 4px;
`, hl = b.div`
  flex: none;
  flex-grow: 0;
  order: 0;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 19px;
  color: ${j.colors.primaryVariant};
`, vl = b.button`
  display: flex;
  flex: none;
  flex-direction: row;
  flex-grow: 0;
  gap: 10px;
  align-items: center;
  justify-content: center;
  order: 1;
  padding: 7px 20px;
  background: ${j.colors.primary};
  border-radius: 4px;
`, ml = b.div`
  flex: none;
  flex-grow: 0;
  order: 0;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
  color: ${j.colors.white};
`, gl = (e) => {
  switch (e) {
    case "ja":
      return "アップロードが成功しました🐱！";
    case "en":
      return "Upload succeeded🐱!";
    default:
      return le();
  }
}, yl = (e) => {
  switch (e) {
    case "ja":
      return "閉じる";
    case "en":
      return "close";
    default:
      return le();
  }
}, Lr = (e) => {
  switch (e) {
    case "ja":
      return "Markdownソースをコピー";
    case "en":
      return "Copy Markdown source";
    default:
      return le();
  }
}, xl = (e) => {
  switch (e) {
    case "ja":
      return `LGTM画像を作成しているので少々お待ち下さい。「${Lr(
        e
      )}」ボタンか上の画像をクリックするとMarkdownソースがコピーされます。`;
    case "en":
      return `Please wait a moment while we create the LGTM image. Click on the "${Lr(
        e
      )}" button or the image above to copy the Markdown source.`;
    default:
      return le();
  }
}, bl = (e) => {
  switch (e) {
    case "ja":
      return "※トップページの「New arrival Cats」ボタンを押下するとアップロードした画像を確認できます。";
    case "en":
      return '※Click the "New arrival Cats" button on the top page to see the uploaded images.';
    default:
      return le();
  }
}, wl = ({
  language: e,
  createdLgtmImageUrl: t,
  onClickClose: r,
  appUrl: n,
  callback: a
}) => {
  const { copied: i, onCopySuccess: u } = Zt(a), { imageContextRef: o } = Xt({
    onCopySuccess: u,
    imageUrl: t,
    appUrl: n ?? rr
  });
  return /* @__PURE__ */ l.jsxs(al, { children: [
    /* @__PURE__ */ l.jsx(il, { children: gl(e) }),
    /* @__PURE__ */ l.jsxs(sl, { children: [
      /* @__PURE__ */ l.jsx(cl, { children: xl(e) }),
      /* @__PURE__ */ l.jsxs(ll, { children: [
        /* @__PURE__ */ l.jsx(ul, { children: /* @__PURE__ */ l.jsx(fl, { children: bl(e) }) }),
        /* @__PURE__ */ l.jsxs(dl, { children: [
          /* @__PURE__ */ l.jsx(pl, { onClick: r, children: /* @__PURE__ */ l.jsx(hl, { children: yl(e) }) }),
          /* @__PURE__ */ l.jsx(vl, { ref: o, children: /* @__PURE__ */ l.jsx(ml, { children: Lr(e) }) })
        ] })
      ] }),
      i ? /* @__PURE__ */ l.jsx(nr, {}) : ""
    ] })
  ] });
}, El = b.div`
  @media (max-width: ${j.mediaQuerySize.default}) {
    width: 360px;
  }
  position: absolute;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
  width: 500px;
  padding: 27px 30px 45px;
  background: ${j.colors.background};
  border: 1px dashed ${j.colors.subText};
`, _l = b.div`
  display: flex;
  flex: none;
  flex-direction: column;
  flex-grow: 0;
  gap: 14px;
  align-items: center;
  order: 0;
  padding: 0;
`, Sl = b.div`
  flex: none;
  flex-grow: 0;
  order: 0;
  font-family: Roboto, sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  color: ${j.colors.subText};
  text-align: center;
`, Ol = b.div`
  display: flex;
  flex: none;
  flex-direction: column;
  flex-grow: 0;
  gap: 16px;
  align-items: center;
  order: 1;
  padding: 0;
`, Tl = b.div`
  flex: none;
  flex-grow: 0;
  order: 0;
`, Cl = b.img`
  @media (max-width: ${j.mediaQuerySize.default}) {
    max-width: 355px;
  }
  flex: none;
  flex-grow: 0;
  order: 0;
  width: auto;
  height: 270px;
`, jl = b.div`
  flex: none;
  flex-grow: 0;
  order: 1;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  color: ${j.colors.subText};
`, Rl = (e) => {
  switch (e) {
    case "ja":
      return "猫ちゃん画像アップロード確認";
    case "en":
      return "Cat image upload confirmed";
    default:
      return le();
  }
}, Al = (e) => {
  switch (e) {
    case "ja":
      return "この画像をアップロードします。よろしいですか？";
    case "en":
      return "Upload this image. Are you sure?";
    default:
      return le();
  }
}, Dl = `@media (maxWidth: ${j.mediaQuerySize.default})`, wr = {
  // stylelint-disable-next-line
  overlay: {
    background: "rgba(54, 46, 43, 0.7)"
  },
  content: {
    // stylelint-disable-next-line selector-type-case, selector-type-no-unknown
    [Dl]: {
      width: "370px"
    },
    inset: "0",
    width: "540px",
    height: "540px",
    margin: "auto"
  }
}, Pl = ({
  isOpen: e,
  language: t,
  imagePreviewUrl: r,
  onClickUpload: n,
  onClickCancel: a,
  onClickClose: i,
  isLoading: u,
  uploaded: o = !1,
  createdLgtmImageUrl: f,
  onClickCreatedLgtmImage: c,
  onClickMarkdownSourceCopyButton: d,
  appUrl: p
}) => (o ? wr.content.height = "705px" : wr.content.height = "540px", /* @__PURE__ */ l.jsx(
  go,
  {
    isOpen: e,
    ariaHideApp: !1,
    style: wr,
    onRequestClose: a,
    children: /* @__PURE__ */ l.jsx(El, { children: /* @__PURE__ */ l.jsxs(_l, { children: [
      /* @__PURE__ */ l.jsx(Sl, { children: Rl(t) }),
      /* @__PURE__ */ l.jsxs(Ol, { children: [
        o ? /* @__PURE__ */ l.jsx(
          ol,
          {
            imagePreviewUrl: r,
            createdLgtmImageUrl: f,
            callback: c,
            appUrl: p
          }
        ) : /* @__PURE__ */ l.jsx(Tl, { children: /* @__PURE__ */ l.jsx(Cl, { src: r }) }),
        !u && !o ? /* @__PURE__ */ l.jsx(l.Fragment, { children: /* @__PURE__ */ l.jsx(jl, { children: Al(t) }) }) : ""
      ] }),
      o && f && !u ? /* @__PURE__ */ l.jsx(
        wl,
        {
          language: t,
          createdLgtmImageUrl: f,
          onClickClose: i,
          callback: d,
          appUrl: p
        }
      ) : "",
      !o && !f && !u ? /* @__PURE__ */ l.jsx(
        tl,
        {
          language: t,
          onClickUpload: n,
          onClickCancel: a
        }
      ) : "",
      u ? /* @__PURE__ */ l.jsx(Yc, { language: t }) : ""
    ] }) })
  }
)), Ml = b.div`
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  color: ${j.colors.text};
`, kl = (e) => {
  switch (e) {
    case "ja":
      return "猫ちゃん画像をアップロードしてLGTM画像を作れます🐱";
    case "en":
      return "You can upload cat images to create LGTM images🐱";
    default:
      return le();
  }
}, Fl = ({ language: e }) => /* @__PURE__ */ l.jsx(Ml, { children: kl(e) }), $l = b.div`
  display: flex;
  flex: none;
  flex-direction: column;
  flex-grow: 0;
  gap: 61px;
  align-items: center;
  order: 0;
  padding: 0;
`, Ll = b.form`
  @media (max-width: ${j.mediaQuerySize.default}) {
    width: 380px;
  }
  flex: none;
  flex-grow: 0;
  order: 1;
  width: 500px;
`, Il = b.div`
  box-sizing: border-box;
  display: grid;
  height: 220px;
  background: ${j.colors.white};
  border: 1px dashed ${j.colors.text};
`, Nl = b.div`
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  color: ${j.colors.subText};
  text-align: center;
`, Wl = b.input`
  display: none;
`, Ul = b.label`
  inset: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: center;
  height: 43px;
  padding: 12px 20px;
  margin: auto;
  cursor: pointer;
  background: ${j.colors.background};
  border: 1px solid ${j.colors.subText};
  border-radius: 4px;
`, zl = b.div`
  flex: none;
  flex-grow: 0;
  order: 0;
  width: 160px;
  height: 19px;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 19px;
  color: ${j.colors.primaryVariant};
`, Bl = b.div`
  height: 28px;
  font-family: Roboto, sans-serif;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  color: ${j.colors.subText};
  text-align: right;
`, Hl = b.div`
  height: 28px;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  color: ${j.colors.text};
  text-align: center;
`, Vl = b.div`
  top: 609px;
  height: 96px;
  font-family: Roboto, sans-serif;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: ${j.colors.text};
`, ql = b.div`
  display: grid;
  gap: 24px;
`, Bn = b.div`
  height: 42px;
  font-family: Roboto, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  color: ${j.colors.text};
  text-align: center;
`, Hn = b.span`
  height: 42px;
  font-family: Roboto, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  color: ${j.colors.primary};
  text-align: center;
  text-decoration-line: underline;
  cursor: pointer;
`, Yl = b.div`
  display: flex;
  align-items: center;
  justify-content: center;
`, Gl = (e) => {
  switch (e) {
    case "ja":
      return "ここに画像をドロップ";
    case "en":
      return "Drop image here";
    default:
      return le();
  }
}, Kl = (e) => {
  switch (e) {
    case "ja":
      return "またはファイルの選択";
    case "en":
      return "Select an image file";
    default:
      return le();
  }
}, Ql = (e) => {
  switch (e) {
    case "ja":
      return "注意事項";
    case "en":
      return "precautions";
    default:
      return le();
  }
}, Jl = (e) => {
  switch (e) {
    case "ja":
      return [
        "拡張子が png, jpg, jpeg の画像のみアップロード出来ます。",
        "猫が写っていない画像はアップロード出来ません。",
        "人の顔がはっきり写っている画像はアップロード出来ません。",
        "猫のイラスト等は正確に判定出来ない事があります。"
      ];
    case "en":
      return [
        "png, jpg, jpeg, images are available.",
        "Images without cats cannot be uploaded.",
        "Images that clearly show a person's face cannot be uploaded.",
        "Illustrations of cats may not be accurately determined."
      ];
    default:
      return le();
  }
}, Xl = (e, t) => {
  switch (t) {
    case "ja":
      return [
        `${e} の画像は許可されていません。`,
        "png, jpg, jpeg の画像のみアップロード出来ます。"
      ];
    case "en":
      return [
        `${e} is not allowed.`,
        "Only png, jpg, jpeg images can be uploaded."
      ];
    default:
      return le();
  }
}, Zl = (e) => {
  switch (e) {
    case "ja":
      return [
        "予期せぬエラーが発生しました。",
        "お手数ですが、しばらく時間が経ってからお試し下さい。"
      ];
    case "en":
      return [
        "An unexpected error occurred during upload.",
        "Sorry, please try again after some time has passed."
      ];
    default:
      return le();
  }
}, eu = {
  fontStyle: "normal",
  fontWeight: 900,
  fontSize: "42px",
  lineHeight: "39px",
  color: `${j.colors.primaryVariant}`,
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  margin: "auto"
}, tu = (e) => {
  const t = Dt(e);
  switch (e) {
    case "ja":
      return /* @__PURE__ */ l.jsxs(Bn, { children: [
        "アップロードするボタンを押下することで",
        " ",
        /* @__PURE__ */ l.jsx(Oe, { href: t.link, prefetch: !1, children: /* @__PURE__ */ l.jsx(Hn, { children: t.text }) }),
        " ",
        "に同意したと見なします"
      ] });
    case "en":
      return /* @__PURE__ */ l.jsxs(Bn, { children: [
        "By pressing the upload button, you agree to the",
        " ",
        /* @__PURE__ */ l.jsx(Oe, { href: t.link, prefetch: !1, children: /* @__PURE__ */ l.jsx(Hn, { children: t.text }) }),
        " ",
        "."
      ] });
    default:
      return le();
  }
}, ru = ({
  language: e,
  imageValidator: t,
  imageUploader: r,
  uploadCallback: n,
  onClickCreatedLgtmImage: a,
  onClickMarkdownSourceCopyButton: i,
  appUrl: u
}) => {
  const [o, f] = Ce(""), [c, d] = Ce(""), [p, v] = Ce(""), [w, O] = Ce(!1), [y, D] = Ce(), [W, X] = Ce(""), [H, U] = Ce(
    []
  ), [E, Z] = Ce(!1), oe = () => {
    O(!0);
  }, ue = () => {
    D(!1), X(""), O(!1);
  }, I = () => {
    d(""), v(""), Z(!1), ue();
  }, z = (L) => {
    var _;
    if (L.target === null)
      return;
    const m = (_ = L.target) == null ? void 0 : _.result;
    typeof m == "string" && f(window.btoa(m));
  }, B = (L) => {
    D(!1);
    const m = L.type;
    if (!no(m)) {
      U(
        Xl(m, e)
      ), I();
      return;
    }
    const _ = URL.createObjectURL(L);
    d(_), v(Ca(m));
    const T = new FileReader();
    T.onload = z, T.readAsBinaryString(L), oe();
  }, re = (L) => {
    if (L.preventDefault(), L.target.files && L.target.files.length > 0) {
      const _ = L.target.files[0];
      B(_);
    }
  }, te = () => H.length !== 0 ? !0 : c === "", A = (L) => {
    L.preventDefault(), oe();
  }, k = async () => {
    Z(!0);
    try {
      const L = await t(
        o,
        p
      );
      if (!L.value.isAcceptableCatImage || // eslint-disable-next-line no-magic-numbers
      L.value.notAcceptableReason.length !== 0) {
        U(
          L.value.notAcceptableReason
        ), I();
        return;
      }
      const m = await r(
        o,
        p
      );
      Z(!1), m.value.createdLgtmImageUrl && (D(!0), U([]), X(m.value.createdLgtmImageUrl), n && n()), m.value.displayErrorMessages.length !== 0 && (U(m.value.displayErrorMessages), I());
    } catch (L) {
      if (U(Zl(e)), I(), L instanceof Error)
        throw L;
    } finally {
      Z(!1);
    }
  }, Y = () => {
    ue();
  }, h = Ee((L) => {
    if (L.length > 0) {
      const _ = L[0];
      B(_);
    }
  }, []), { getRootProps: N } = Ao({ onDrop: h });
  return /* @__PURE__ */ l.jsxs($l, { children: [
    H.length === 0 ? "" : /* @__PURE__ */ l.jsx(Wc, { messages: H }),
    /* @__PURE__ */ l.jsx(Fl, { language: e }),
    /* @__PURE__ */ l.jsxs(Ll, { children: [
      /* @__PURE__ */ l.jsx("div", { ...N(), children: /* @__PURE__ */ l.jsxs(Il, { children: [
        /* @__PURE__ */ l.jsx(Br, { style: eu }),
        /* @__PURE__ */ l.jsx(Nl, { children: Gl(e) }),
        /* @__PURE__ */ l.jsxs(Ul, { children: [
          /* @__PURE__ */ l.jsx(zl, { children: Kl(e) }),
          /* @__PURE__ */ l.jsx(Wl, { type: "file", onChange: re })
        ] })
      ] }) }),
      /* @__PURE__ */ l.jsx(Bl, { children: "Maximum upload size is 4MB" }),
      /* @__PURE__ */ l.jsxs(ql, { children: [
        /* @__PURE__ */ l.jsx(Hl, { children: Ql(e) }),
        /* @__PURE__ */ l.jsx(Vl, { children: Jl(e).map((L, m) => /* @__PURE__ */ l.jsx("p", { children: L }, m)) }),
        tu(e)
      ] }),
      /* @__PURE__ */ l.jsx(Yl, { children: /* @__PURE__ */ l.jsx(
        $c,
        {
          language: e,
          disabled: te(),
          onClick: A
        }
      ) })
    ] }),
    c || W ? /* @__PURE__ */ l.jsx(
      Pl,
      {
        isOpen: w,
        language: e,
        imagePreviewUrl: c,
        onClickUpload: k,
        onClickCancel: ue,
        onClickClose: Y,
        isLoading: E,
        uploaded: y,
        createdLgtmImageUrl: W,
        onClickCreatedLgtmImage: a,
        onClickMarkdownSourceCopyButton: i,
        appUrl: u
      }
    ) : ""
  ] });
}, Fo = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAA2ElEQVRYhcXXzQ3CMAyG4dcVRxagC7D/OlwqFuiRG3UPFagtFPJjx1nge6Qo8WdR1R64sD1P4CYiD5xPFxmuqv0pMPwKnLvIcFiuAGCKCF8D7hHhL8AgImOD8H4fDiDewavw/WsDGNwBB+ETy7WProCUT84NkPrDugByvndzQO5sMQWUDDYzQOlUNQHUjPRqQG2fqAJYlJligFWTKgJY1rhsgHWHzAJ4FNhkgFd7TgJ4Vve/AO+94SegxdJyCGi1MX0FtFzXPgCtd8UNIGJRfQOitmSJDAeYAU0pvDaovTStAAAAAElFTkSuQmCC", nu = Fo, ou = b.button`
  ${j.buttonBase};
  width: 227px;
  background: ${j.colors.primary} url(${nu}) repeat 0 0/16px auto;
`, au = b.div`
  ${j.buttonText};
`, iu = {
  fontStyle: "normal",
  fontWeight: 900,
  fontSize: "26px",
  lineHeight: "26px",
  color: `${j.colors.white}`,
  flex: "none",
  order: 0,
  flexGrow: 0
}, su = ({
  imageUrl: e,
  callback: t,
  appUrl: r
}) => {
  const { copied: n, onCopySuccess: a } = Zt(t), { imageContextRef: i } = Xt({
    onCopySuccess: a,
    imageUrl: e,
    appUrl: r ?? rr
  });
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsxs(ou, { ref: i, children: [
      /* @__PURE__ */ l.jsx(Ha, { style: iu }),
      /* @__PURE__ */ l.jsx(au, { children: "Cats Random Copied" })
    ] }),
    n ? /* @__PURE__ */ l.jsx(nr, { position: "upper" }) : ""
  ] });
}, cu = Fo, lu = b.span`
  background: ${j.colors.primary} url(${cu}) repeat 0 0/16px auto;
  ${j.buttonBase};
`, uu = b.span`
  ${j.buttonText};
`, fu = {
  fontStyle: "normal",
  fontWeight: 900,
  fontSize: "26px",
  lineHeight: "26px",
  color: `${j.colors.sub}`,
  flex: "none",
  order: 0,
  flexGrow: 0
}, du = ({
  link: e,
  customDataAttrGtmClick: t
}) => /* @__PURE__ */ l.jsx(Oe, { href: e, prefetch: !1, style: { textDecoration: "none" }, children: /* @__PURE__ */ l.jsxs(lu, { "data-gtm-click": t, children: [
  /* @__PURE__ */ l.jsx(
    Br,
    {
      style: fu,
      "data-gtm-click": t
    }
  ),
  /* @__PURE__ */ l.jsx(uu, { "data-gtm-click": t, children: "Upload new Cats" })
] }) }), pu = b.button`
  background: ${j.colors.primary};
  ${j.buttonBase};
`, hu = b.div`
  ${j.buttonText};
`, vu = {
  fontStyle: "normal",
  fontWeight: 900,
  fontSize: "26px",
  lineHeight: "26px",
  color: `${j.colors.sub}`,
  flex: "none",
  order: 0,
  flexGrow: 0
}, mu = (e) => {
  switch (e) {
    case "refresh":
      return "Cats Refresh";
    case "new":
      return "New arrival Cats";
    default:
      return le();
  }
}, Vn = ({ type: e, onClick: t }) => /* @__PURE__ */ l.jsxs(pu, { onClick: t, children: [
  /* @__PURE__ */ l.jsx(Va, { style: vu }),
  /* @__PURE__ */ l.jsx(hu, { children: mu(e) })
] }), gu = b.div`
  @media (max-width: ${j.mediaQuerySize.default}) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  gap: 10px;
  padding: 16px 75px;
  background: ${j.colors.white};
`, yu = b.div`
  @media (max-width: ${j.mediaQuerySize.default}) {
    flex: none;
    flex-direction: column;
    flex-grow: 0;
    order: 0;
  }
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
  justify-content: center;
  padding: 0;
`, xu = ({
  onClickFetchRandomCatButton: e,
  onClickFetchNewArrivalCatButton: t
}) => /* @__PURE__ */ l.jsx(gu, { children: /* @__PURE__ */ l.jsxs(yu, { children: [
  /* @__PURE__ */ l.jsx(
    du,
    {
      link: "/upload",
      customDataAttrGtmClick: "top-upload-cat-button"
    }
  ),
  /* @__PURE__ */ l.jsx(Vn, { type: "refresh", onClick: e }),
  /* @__PURE__ */ l.jsx(Vn, { type: "new", onClick: t })
] }) }), bu = b.span`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: center;
  padding: 8px 20px;
  cursor: pointer;
  background: ${j.colors.primary};
  border-radius: 4px;
  &:hover {
    opacity: 0.8;
  }
`, wu = b.span`
  flex: none;
  flex-grow: 0;
  order: 0;
  width: 144px;
  height: 18px;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px;
  color: ${j.colors.white};
  &:hover {
    opacity: 0.8;
  }
`, qn = {
  ja: "トップページに戻る",
  en: "Back to Top Page"
}, Eu = (e) => {
  switch (e) {
    case "ja":
      return qn.ja;
    case "en":
      return qn.en;
    default:
      return le();
  }
}, _u = ({ language: e }) => /* @__PURE__ */ l.jsx(Oe, { href: "/", prefetch: !1, style: { textDecoration: "none" }, children: /* @__PURE__ */ l.jsx(bu, { children: /* @__PURE__ */ l.jsx(wu, { children: Eu(e) }) }) }), Su = b.div`
  display: flex;
  flex-direction: column;
  gap: 64px;
  align-items: center;
  justify-content: center;
`, Ou = b.div`
  font-family: Roboto, sans-serif;
  font-size: 70px;
  font-style: normal;
  font-weight: 700;
  line-height: 70px;
  color: ${j.colors.text};
  text-align: center;
`, Tu = b.div`
  position: relative;
  width: 240px;
  height: 240px;
`, Cu = b.div`
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px;
  color: ${j.colors.text};
  text-align: center;
`, Er = {
  notFound: "404 Not Found",
  internalServerError: "500 Internal Server Error",
  serviceUnavailable: "503 Service Unavailable"
}, ju = (e) => {
  switch (e) {
    case Xe.notFound:
      return Er.notFound;
    case Xe.internalServerError:
      return Er.internalServerError;
    case Xe.serviceUnavailable:
      return Er.serviceUnavailable;
    default:
      return le();
  }
}, _r = {
  notFound: "お探しのページは見つかりません。一時的にアクセス出来ない状態か、移動もしくは削除されてしまった可能性があります。",
  internalServerError: "システムエラーが発生しました。申し訳ありませんがしばらく時間がたってからお試しください。",
  serviceUnavailable: "メンテナンス中です。申し訳ありませんがしばらく時間がたってからお試しください。"
}, Sr = {
  notFound: "The page you are looking for cannot be found. It is temporarily inaccessible or has been removed.",
  internalServerError: "A system error has occurred. Sorry, please try again after some time has passed.",
  serviceUnavailable: "The system is under maintenance. Sorry, please try again after some time has passed."
}, Ru = (e, t) => {
  switch (e) {
    case Xe.notFound:
      switch (t) {
        case "ja":
          return _r.notFound;
        case "en":
          return Sr.notFound;
        default:
          return le();
      }
    case Xe.internalServerError:
      switch (t) {
        case "ja":
          return _r.internalServerError;
        case "en":
          return Sr.internalServerError;
        default:
          return le();
      }
    case Xe.serviceUnavailable:
      switch (t) {
        case "ja":
          return _r.serviceUnavailable;
        case "en":
          return Sr.serviceUnavailable;
        default:
          return le();
      }
    default:
      return le();
  }
}, $o = ({
  type: e,
  catImage: t,
  language: r,
  shouldDisplayBackToTopButton: n
}) => /* @__PURE__ */ l.jsxs(Su, { children: [
  /* @__PURE__ */ l.jsx(Ou, { children: ju(e) }),
  /* @__PURE__ */ l.jsx(Tu, { children: t }),
  /* @__PURE__ */ l.jsx(Cu, { children: Ru(e, r) }),
  n ? /* @__PURE__ */ l.jsx(_u, { language: r }) : ""
] });
function Au(e) {
  return We({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9H9V9h10v2zm-4 4H9v-2h6v2zm4-8H9V5h10v2z" } }] })(e);
}
const Du = {
  width: "69.31px",
  height: "69.31px",
  color: `${j.colors.variant}`,
  background: `${j.colors.white}`
}, Pu = () => /* @__PURE__ */ l.jsx(Au, { style: Du }), Mu = b.div`
  display: grid;
  grid-template-rows: auto 1fr auto;
  grid-template-columns: 100%;
  gap: 64px;
  min-height: 100vh;
`, ku = b.div`
  display: inline-block;
  margin: 0 auto;
  text-align: center;
  vertical-align: middle;
`, or = ({
  language: e,
  isLanguageMenuDisplayed: t,
  onClickLanguageButton: r,
  currentUrlPath: n,
  children: a
}) => /* @__PURE__ */ l.jsxs(Mu, { children: [
  /* @__PURE__ */ l.jsx(
    Ps,
    {
      language: e,
      isLanguageMenuDisplayed: t,
      onClickLanguageButton: r,
      currentUrlPath: n
    }
  ),
  /* @__PURE__ */ l.jsx(ku, { children: a }),
  /* @__PURE__ */ l.jsx(Ia, { language: e })
] }), cf = ({
  type: e,
  language: t,
  catImage: r,
  currentUrlPath: n
}) => {
  const { isLanguageMenuDisplayed: a, onClickLanguageButton: i, onClickOutSideMenu: u } = zr();
  return /* @__PURE__ */ l.jsx("div", { onClick: u, "aria-hidden": "true", children: /* @__PURE__ */ l.jsx(
    or,
    {
      language: t,
      isLanguageMenuDisplayed: a,
      onClickLanguageButton: i,
      currentUrlPath: n,
      children: /* @__PURE__ */ l.jsx(
        $o,
        {
          type: e,
          language: t,
          catImage: r,
          shouldDisplayBackToTopButton: !0
        }
      )
    }
  ) });
}, Fu = b.div`
  display: grid;
  grid-template-columns: 302px 302px 302px;
  @media (max-width: ${j.mediaQuerySize.default}) {
    grid-template-columns: 302px;
    justify-content: center;
  }
`, lf = ({
  language: e,
  imageValidator: t,
  imageUploader: r,
  catImage: n,
  uploadCallback: a,
  onClickCreatedLgtmImage: i,
  onClickMarkdownSourceCopyButton: u,
  appUrl: o
}) => {
  const { isLanguageMenuDisplayed: f, onClickLanguageButton: c, onClickOutSideMenu: d } = zr();
  return /* @__PURE__ */ l.jsx("div", { onClick: d, "aria-hidden": "true", children: /* @__PURE__ */ l.jsxs(
    or,
    {
      language: e,
      isLanguageMenuDisplayed: f,
      onClickLanguageButton: c,
      currentUrlPath: "/upload",
      children: [
        /* @__PURE__ */ l.jsx(
          ru,
          {
            language: e,
            imageValidator: t,
            imageUploader: r,
            uploadCallback: a,
            onClickCreatedLgtmImage: i,
            onClickMarkdownSourceCopyButton: u,
            appUrl: o
          }
        ),
        /* @__PURE__ */ l.jsx(Fu, { children: n })
      ]
    }
  ) });
}, $u = b.h1`
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  color: ${j.colors.text};
`, Lu = ({ text: e }) => /* @__PURE__ */ l.jsx($u, { children: e }), Iu = (e, t) => {
  switch (e) {
    case "privacy":
      return Dt(t).text;
    case "terms":
      return er(t).text;
    default:
      return le();
  }
}, Nu = b.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  justify-content: center;
`, Wu = b.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 750px;
  font-family: Roboto, sans-serif;
  font-size: 20px;
  font-style: normal;
  line-height: 25px;
  text-align: left;
  overflow-wrap: normal;
  list-style-position: inside;
  @media (max-width: ${j.mediaQuerySize.default}) {
    max-width: 380px;
  }
`, uf = ({
  type: e,
  language: t,
  isLanguageMenuDisplayed: r,
  onClickLanguageButton: n,
  onClickOutSideMenu: a,
  children: i
}) => {
  const u = e === "terms" ? er(t).link : Dt(t).link;
  return /* @__PURE__ */ l.jsx("div", { onClick: a, "aria-hidden": "true", children: /* @__PURE__ */ l.jsx(
    or,
    {
      language: t,
      isLanguageMenuDisplayed: r,
      onClickLanguageButton: n,
      currentUrlPath: u,
      children: /* @__PURE__ */ l.jsxs(Nu, { children: [
        /* @__PURE__ */ l.jsx(Lu, { text: Iu(e, t) }),
        /* @__PURE__ */ l.jsx(Pu, {}),
        /* @__PURE__ */ l.jsx(Wu, { children: i })
      ] })
    }
  ) });
}, Lo = b.div``, Io = Ne`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  color: #43281e;
  text-align: center;
`, Yn = b.div`
  font-family: Zen Kaku Gothic New, sans-serif;
  ${Io};
`, Gn = b.div`
  font-family: Roboto, sans-serif;
  ${Io};
`, Uu = "猫のLGTM画像を共有出来るサービスです。", zu = "画像をクリックするとGitHub Markdownがコピーされます。", Bu = "Cat LGTM Image Service.", Hu = "Click on the image to copy the GitHub Markdown.", Vu = () => /* @__PURE__ */ l.jsxs(Lo, { children: [
  /* @__PURE__ */ l.jsx(Yn, { children: Uu }),
  /* @__PURE__ */ l.jsx(Yn, { children: zu })
] }), qu = () => /* @__PURE__ */ l.jsxs(Lo, { children: [
  /* @__PURE__ */ l.jsx(Gn, { children: Bu }),
  /* @__PURE__ */ l.jsx(Gn, { children: Hu })
] }), Yu = ({ language: e }) => {
  switch (e) {
    case "ja":
      return /* @__PURE__ */ l.jsx(Vu, {});
    case "en":
      return /* @__PURE__ */ l.jsx(qu, {});
    default:
      return le();
  }
}, Gu = b.div`
  display: grid;
  gap: 20px;
  align-items: center;
  justify-content: center;
  padding: 0;
`, Ku = ({
  appUrl: e,
  imageUrl: t,
  callback: r
}) => /* @__PURE__ */ l.jsx(Gu, { children: /* @__PURE__ */ l.jsx(
  su,
  {
    appUrl: e,
    imageUrl: t,
    callback: r
  }
) }), Qu = b.div`
  display: grid;
  grid-template-rows: auto 1fr auto;
  grid-template-columns: 100%;
  gap: 32px;
`, Ju = ({
  language: e,
  lgtmImages: t,
  errorCatImage: r,
  onClickFetchRandomCatButton: n,
  onClickFetchNewArrivalCatButton: a,
  appUrl: i,
  catRandomCopyCallback: u,
  clipboardMarkdownCallback: o
}) => {
  const f = Zn(ya()), c = f.lgtmImages ? f.lgtmImages : t, { isFailedFetchLgtmImages: d } = f, { imageUrl: p } = c[Math.floor(Math.random() * c.length)];
  return /* @__PURE__ */ l.jsxs(Qu, { children: [
    /* @__PURE__ */ l.jsx(Yu, { language: e }),
    /* @__PURE__ */ l.jsx(
      Ku,
      {
        appUrl: i,
        imageUrl: p,
        callback: u
      }
    ),
    /* @__PURE__ */ l.jsx(
      xu,
      {
        onClickFetchRandomCatButton: n,
        onClickFetchNewArrivalCatButton: a
      }
    ),
    d === !0 ? /* @__PURE__ */ l.jsx(
      $o,
      {
        type: Xe.internalServerError,
        language: e,
        catImage: r,
        shouldDisplayBackToTopButton: !1
      }
    ) : /* @__PURE__ */ l.jsx(
      Is,
      {
        images: c,
        appUrl: i,
        callback: o
      }
    )
  ] });
}, ff = ({
  language: e,
  lgtmImages: t,
  randomCatImagesFetcher: r,
  newArrivalCatImagesFetcher: n,
  errorCatImage: a,
  appUrl: i,
  clipboardMarkdownCallback: u,
  fetchRandomCatImagesCallback: o,
  fetchNewArrivalCatImagesCallback: f,
  catRandomCopyCallback: c
}) => {
  const { isLanguageMenuDisplayed: d, onClickLanguageButton: p, onClickOutSideMenu: v } = zr(), w = async () => {
    try {
      const y = await r();
      cn(y), Ft(!1), o && o();
    } catch (y) {
      throw Ft(!0), y instanceof Error ? new dr(y.message) : new dr("failed to randomCatImagesFetcher");
    }
  }, O = async () => {
    try {
      const y = await n();
      cn(y), Ft(!1), f && f();
    } catch (y) {
      throw Ft(!0), y instanceof Error ? new Sa(y.message) : new dr(
        "failed to newArrivalCatImagesFetcher"
      );
    }
  };
  return /* @__PURE__ */ l.jsx("div", { onClick: v, "aria-hidden": "true", children: /* @__PURE__ */ l.jsx(
    or,
    {
      language: e,
      isLanguageMenuDisplayed: d,
      onClickLanguageButton: p,
      currentUrlPath: "/",
      children: /* @__PURE__ */ l.jsx(
        Ju,
        {
          language: e,
          lgtmImages: t,
          errorCatImage: a,
          onClickFetchRandomCatButton: w,
          onClickFetchNewArrivalCatButton: O,
          appUrl: i,
          catRandomCopyCallback: c,
          clipboardMarkdownCallback: u
        }
      )
    }
  ) });
};
export {
  cf as ErrorTemplate,
  uf as TermsOrPrivacyTemplate,
  ff as TopTemplate,
  lf as UploadTemplate,
  of as createFailureResult,
  nf as createSuccessResult,
  Xe as errorType,
  sf as isFailureResult,
  af as isSuccessResult,
  zr as useSwitchLanguage
};
